let ES6Promise = require("es6-promise");
//ES6Promise.polyfill();
import Axios from "axios";
import React, { Component, IframeHTMLAttributes, lazy } from "react";
import "./assets/css/mystyle.pcss";
import ClearSessionOverlay from "./src/Components/BaseComponents/ClearSessionOverlay";
import BotIcon from "./src/Components/FeatureComponents/BotIcon";
import Header from "./src/Components/FeatureComponents/Header";
import DataAPI from "./src/Utils/Api";
import MDUtil from "./src/Utils/MDUtil";
import debounce from "./src/Utils/Reactive";
import TimeUtil from "./src/Utils/TimeUtil";
import encryptChatData from "./src/Components/FeatureComponents/EncryptChat";
import isInsignia from "./src/Utils/IsInsignia";
import logoutApi from "./src/Components/FeatureComponents/SessionTimeout/LogoutApi";
import showSnackBar from "./src/Components/BaseComponents/SnackBar";

//@ts-ignore;
import thinkingGif from "./assets/imgs/icons/thinking.gif";
//@ts-ignore;
import FDGif from "./assets/imgs/FD.gif";
//@ts-ignore;
import BBPS_Logo from "./assets/imgs/BBPS_Logo.svg";

import ChatBody from "./src/Components/FeatureComponents/ChatBody";
import ChatOverlay from "./src/Components/FeatureComponents/ChatOverlay";
import SFModal from "./src/Components/BaseComponents/SFModal";
import LoginScreen from "./src/Components/BaseComponents/LoginScreen";
import LiveAgentScreen from "./src/Components/BaseComponents/LiveAgentScreen";
import SessionTimeoutHandler from "./src/Components/FeatureComponents/SessionTimeout/SessionTimeoutHandler";
//@ts-ignore;
import ChatInput from "src/Components/FeatureComponents/ChatInput";
//@ts-ignore;
import books from "./assets/imgs/Books.png";
//@ts-ignore;
import electricity from "./assets/imgs/electricity.png";
//@ts-ignore;
import mobile from "./assets/imgs/mobile.png";
//@ts-ignore;
import water from "./assets/imgs/water.png";
//@ts-ignore;
import wifi from "./assets/imgs/wifi.png";
//@ts-ignore;
import email from "./assets/imgs/email.png";
import OverlayMessage from "./src/Components/FeatureComponents/OverlayMessage";
//@ts-ignore;
import QuickLinkData from "./QuickLinkData.json";
//@ts-ignore;//
import CrestGIF from "./assets/imgs/crest.png";
//@ts-ignore;
import DepositImage from "./assets/imgs/DepositPopup.gif";
import { type } from "os";
import { wrapperEndPoint } from "./src/Utils/Api";
import { stringify } from "postcss";
import close from "./assets/imgs/close.svg";

import CryptoJS from "./src/Components/FeatureComponents/EncryptChat/aes";
import CryptoJS1 from "./src/Components/FeatureComponents/EncryptChat/pbkdf2";
// const ChatBody = lazy(() => import(/* webpackChunkName : "body" */ './src/Components/FeatureComponents/ChatBody'));
// const ChatOverlay = lazy(() => import(/* webpackChunkName : "overlay" */ './src/Components/FeatureComponents/ChatOverlay'));
// const SFModal = lazy(() => import(/* webpackChunkName : "modal" */ './src/Components/BaseComponents/SFModal'));

interface IMessage {
  message;
  timeStamp;
  isFeedbackVisible;
  key;
  messageType;
  customInfos;
}

interface IProps {
  botName;
  botWelcomeMessage;
  botQuickLinks;
  botID;
  data;
  showBot;
  mobankApp;
  mycardApp;
  netbanking;
  website;
}

interface State {
  tncChecked;
  isGettingStarted;
  isBotVisible;
  isDownTimeAlertVisible: boolean;
  isDownTime;
  downTimeMsg;
  downTimeST;
  downTimeET;
  isPushBotVisible: boolean; //pushBotVisible
  isOverlayVisible;
  isChatBodyVisible;
  isIdle;
  showWelcomeScreen: boolean;
  showLoginScreen: boolean;
  showLiveAgentScreen: boolean;
  liveAgentData?;
  sessionTimeout: boolean;
  logoutUser: boolean;
  // showDownTimeModal:boolean,
  isLoggedIn: boolean;
  chatMessages: Array<IMessage>;
  entityName;
  chatInput;
  chatInputDisplayValue;
  chatInputOldValue;
  isSpeech;
  isModalVisible;
  isSessionExpire;
  isFileUploadBlockVisible;
  predSearchToggle;
  predSearchResponse;
  selectedTheme;
  workflowActive: boolean;
  isBbpsBiller: boolean;
  isInputDisabled; //disable i/p
  isOverlayPopUpVisible: boolean; //crest promotion
  eligibleCrest: boolean;
  firstWorkflow: boolean;
  eligibleDeposit: boolean;
  isConfirmButtonVisible: boolean;
  numbersOnly;
  value;
  selectedStar;
  uniqueUserId;
  preLoginQuestion;
  loginOpenFDFlag;
  selectedQuickLink;
  selectedIndex;
  overlayPopUpData;
  currentWorkflowName;
  moBankAppsuggestionsFlag;
  isFeedbackEnable: boolean;
  isCrestDebitCardFlow: boolean;
  isCrestDebitCardApplied: boolean;
  bwayparamSSO;
  uniqueidSSO;
  rekycBankingData;
  loginSTPLFlag;
  loginXcashFlag;
  loginLRSFlag;
  cmsURL;
  CNCLinksData;
  CNCLinksOnClick;
  setWorkflowName;
  isBotIconVisible: boolean;
  checkBoxJsonData;
  checkBoxFlag;
  termsCheckBox;
  termsCheckBoxFlag;
  termsText;
  termsLink;
  rewardsDataJson;
  showRewardCalender: boolean;
  showFeedbackStars: boolean;
  removeFeedbackOption: boolean;
  apiCallWithoutInput: boolean;
}

enum ChatThemes {
  "Theme1",
  "Theme2",
  "Theme3",
  "null" = null,
}

//OverRide the css..
const AppStyles = (props) => {
  return (
    // props.styles.botId == 277 ?
    <style
      dangerouslySetInnerHTML={{
        __html: `
                @import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700');
                .sf-chatbot {
                    font-family: 'Roboto', sans-serif;
                    font-weight : normal;
                } 
            `,
      }}
    />
    // : null
  );
};

const ChatStyles = (props) => {
  return props.styles.chatBackgroundWallpaper &&
    props.styles.chatBackgroundWallpaper.length > 0 ? (
    <style
      dangerouslySetInnerHTML={{
        __html: `.sf-chatbody{
                            background: url("${props.styles.chatBackgroundWallpaper}") 0% 0% / cover no-repeat;
                } 
    `,
      }}
    />
  ) : null;
};

let SFIconStyles = (props) => {
  return props.styles.botId == 138 ? (
    <style
      dangerouslySetInnerHTML={{
        __html: `
                @media only screen and (min-width: 768px) {
                    .sf-bot-icon{
                        right : 150px;
                    }
                }
            `,
      }}
    />
  ) : null;
};

let _originalSize = window.innerWidth + window.innerHeight;
let moBankData = "";

function getThemeValue(botSkin) {
  var themeType = JSON.parse(botSkin || "0");
  return themeType == 0 ? null : `Theme${themeType}`;
}

class App extends Component<IProps, State> {
  private box: React.RefObject<HTMLInputElement>;
  sessionTimer: any;
  idleSessionTimer: any;
  restartTimer: any;
  userQuestionStored: any;
  transactionResponseAarry: any;
  constructor(props) {
    super(props);
    this.state = this.setInitialState();
    this.box = React.createRef();
    this.sessionTimer = "";
    this.userQuestionStored = "";
    this.restartTimer = "";
    this.idleSessionTimer = "";
  }

  setInitialState = () => {
    var selectedThemeNumber = getThemeValue(this.props.data.botSkin);
    return {
      tncChecked: false,
      isGettingStarted: false, //true,
      selectedTheme: selectedThemeNumber != null ? selectedThemeNumber : null,
      isBotVisible: false, //change here false**
      isDownTimeAlertVisible: false,
      isDownTime: false,
      downTimeMsg: "",
      downTimeST: "",
      downTimeET: "",
      isPushBotVisible: false,
      isOverlayVisible: false,
      isChatBodyVisible: true,
      isFileUploadBlockVisible: false,
      showWelcomeScreen: true, //change here true**
      showLoginScreen: false,
      showLiveAgentScreen: false,
      liveAgentData: "",
      sessionTimeout: false,
      logoutUser: false,
      isSessionExpire: false,
      isLoggedIn: false,
      // showDownTimeModal:false,
      isIdle: false,
      chatMessages: [
        {
          message:
            this.props.botWelcomeMessage &&
            this.props.botWelcomeMessage.length > 0
              ? this.props.botWelcomeMessage
              : "Hi, I'm a Chatbot. Please select a quick link below or type your question in the space provided.",
          timeStamp: TimeUtil.getCurrentTime(new Date()),
          isFeedbackVisible: false,
          key: null,
          messageType: "server",
          customInfos: {},
        },
      ],
      entityName: "",
      chatInputOldValue: "",
      chatInput: "",
      chatInputDisplayValue: "",
      // #TODO : Move down to the Mic Component use the ThemeContext API
      // Have to do the same with all the lower down childs
      // Context should be avoided whenever the job can be done with passing props
      isSpeech: this.props.data.voiceSupport,
      isModalVisible: false,
      predSearchToggle: false,
      predSearchResponse: [],
      workflowActive: false,
      isBbpsBiller: false,
      isConfirmButtonVisible: true,
      isInputDisabled: false, //disable i/p false
      isOverlayPopUpVisible: false, //crest
      overlayPopUpData: {
        popupType: "",
        image: "",
        title: "",
        subTitle: "",
        description: "",
        inputString1: "",
        inputString2: "",
        option1: "",
        option2: "",
      },
      eligibleCrest: false,
      firstWorkflow: false,
      eligibleDeposit: false,
      numbersOnly: false,
      value: "",
      selectedStar: "",
      uniqueUserId: "",
      preLoginQuestion: "",
      loginOpenFDFlag: false,
      loginSTPLFlag: false,
      loginXcashFlag: false,
      loginLRSFlag: false,
      selectedQuickLink: "",
      selectedIndex: "",
      currentWorkflowName: "", //
      moBankAppsuggestionsFlag: false,
      isFeedbackEnable: false,
      isCrestDebitCardFlow: false,
      isCrestDebitCardApplied: false,
      bwayparamSSO: "",
      uniqueidSSO: "",
      rekycBankingData: { flag: false, url: "" },
      cmsURL: "",
      CNCLinksData: [],
      CNCLinksOnClick: false,
      setWorkflowName: "",
      isBotIconVisible: !this.props.netbanking,
      checkBoxJsonData: "",
      checkBoxFlag: "",
      termsCheckBox: "",
      termsCheckBoxFlag: "",
      termsText: "",
      termsLink: "",
      rewardsDataJson: "",
      showRewardCalender: false,
      showFeedbackStars: false,
      removeFeedbackOption: false,
      apiCallWithoutInput: false,
    };
  };

  // crest promotion
  toggleCrestPromotionPopUp() {
    this.setState({
      isOverlayPopUpVisible: !this.state.isOverlayPopUpVisible,
    });
  }

  handleExitRekycBankingOverlay() {
    this.setState({
      rekycBankingData: { flag: false, url: "" },
    });
  }

  // handleExitRekycBankingMessage(){

  //    let okayButton = document.querySelectorAll(".btn-bluenew")
  //    okayButton[0].addEventListener('click', function(event) {
  //     this.handleExitRekycBankingOverlay();

  //   })

  // }

  //isConfirmButtonVisible
  setConfirmButton = (flag) => {
    if (flag == "N") {
      this.setState({
        isConfirmButtonVisible: false,
      });
    }
  };

  //BBPS
  setBbpsBiller = (flag) => {
    if (flag == "N") {
      this.setState({
        isBbpsBiller: false,
      });
    } else if (flag == "Y") {
      this.setState({
        isBbpsBiller: true,
      });
    }
  };

  redirectToExternalBot = () => {
    window.open(
      `/chatsdk.html?botID=` + encodeURIComponent(this.props.data.eB)
    );
  };

  assignPredSearchQues(ev) {
    this.handleSubmit(ev.target.innerText, false, "predictiveSearch");
    this.togglePredSearch();
  }

  toggleOverlay() {
    this.setState((prevState) => {
      return { isOverlayVisible: !prevState.isOverlayVisible };
    });
  }

  toggleChatBody() {
    this.setState(
      (prevState) => {
        return {
          isChatBodyVisible: !prevState.isChatBodyVisible,
          isOverlayVisible: false,
          predSearchToggle: false,
        };
      },
      () => {
        //calling keep alive to know whether the session is expired
        if (this.props.netbanking && this.state.chatMessages.length < 2) {
          window["resetSessionVar"]();
          let data_SS0 = `bwayparam=${this.state.bwayparamSSO}&uniqueid=${this.state.uniqueidSSO}`;
          console.log("KeepAlive, isLoggedIn-True");
          let formData = new FormData(); //formdata object
          formData.append("bwayparam", this.state.bwayparamSSO); //append the values with key, value pair
          formData.append("uniqueid", this.state.uniqueidSSO);
          const config = {
            headers: { "content-type": "multipart/form-data" },
          };
          console.log("Minimise and maximise");
          Axios.post(
            wrapperEndPoint.keepAliveURL + this.state.uniqueidSSO,
            formData,
            config
          )
            .then((response) => {
              if (response.data !== "SUCCESS") {
                clearInterval(this.restartTimer);
                this.setState(
                  {
                    isSessionExpire: true,
                  },
                  () => {
                    logoutApi("logout");
                  }
                );
              } else {
                this.setState({
                  isSessionExpire: false,
                });
              }
            })
            .catch((error) => {
              this.setState(
                {
                  isSessionExpire: true,
                },
                () => {
                  logoutApi("logout");
                }
              );
              console.log(error); //handle error
            });
        }
      }
    );
  }

  togglePredSearch() {
    this.setState({
      predSearchToggle: false,
    });
  }

  // toggleFileUploadBlock(status=false) {
  //     this.setState({
  //         isFileUploadBlockVisible:status
  //     },()=>{
  //         window.dispatchEvent(new Event('resize'));
  //     })
  // }

  hidePredSearch() {
    this.setState({
      predSearchToggle: false,
    });
  }
  storeChecklist(item) {
    let chats = this.state.chatMessages;
    let lastMsg = chats[chats.length - 1];
    lastMsg["checkList"] = item;
    this.setState({
      chatMessages: chats,
    });
  }

  handleInput(ev) {
    const re = /^[0-9\.]+$/;
    if (this.state.numbersOnly == true) {
      if (ev.target.value === "" || re.test(ev.target.value)) {
        this.setState({ chatInput: ev.target.value });
      }
    } else {
      this.setState({ chatInput: ev.target.value });
    }

    // if(this.state.chatInput.length >= 5){
    //     alert("stop")
    // }
    // this.setState({ chatInput: ev.target.value })
    // if ((document.querySelector('.sf-chatbot #chatInput') as HTMLInputElement).classList.contains('sf-mask')) {
    //     return this.state.chatInput.replace(/[a-zA-Z0-9.]/g, 'X');
    // }
    // console.log("userGaveChatInput")
  }

  handleFocus() {
    if (!this.state.isChatBodyVisible)
      this.setState({ isChatBodyVisible: true });
  }

  handlePredSearch = (ev) => {
    // if(this.props.data.predictiveSearch === "true") {
    if (this.state.workflowActive === false) {
      var searchQuery = ev.target.value;
      if (searchQuery.length <= 0) {
        this.hidePredSearch();
      }
      if (ev.keyCode == 27) {
        this.setState({
          predSearchToggle: false,
        });
      }
      // console.log(this.state.chatInputOldValue);
      let strLength = searchQuery.length;
      let oldStrLength = this.state.chatInputOldValue.length;
      let keyChar = searchQuery.substr(strLength - 1, strLength);
      // if (ev.keyCode == 32 || ev.keyCode == 8||keyChar==" "||strLength<oldStrLength) {
      Axios.get(
        window["SF_PRED_SEARCH_URL"] +
          "/api?mode=autosuggest&q=" +
          searchQuery +
          "&botid=" +
          this.props.data.botId +
          "&version=",
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          if (
            typeof response.data == "object" &&
            response.data.search.length > 0 &&
            this.state.chatInput.trim().length > 0
          ) {
            this.setState({
              predSearchToggle: true,
              predSearchResponse: response.data,
            });
          } else {
            this.hidePredSearch();
          }
        })
        .catch((error) => {
          console.log(error);
        });
      // }
    }
  };

  handleKeyDown(ev) {
    let val = ev.target.value;
    this.setState({
      chatInputOldValue: val,
    });
  }

  handleKeyUp(ev, inputSource = "UserText") {
    if (ev.keyCode == 13) {
      this.state.chatInput.length >= 1 &&
      // && this.state.chatInput.length <= 4
      this.state.chatInput.replace(/\s/g, "").length > 0
        ? this.handleSubmit(this.state.chatInput, false, inputSource)
        : 0;
      this.hidePredSearch();
    } else {
      debounce(this.handlePredSearch(ev), 300);
    }
  }

  /*handle Quick Link Submit */
  handleQuickLinkSubmit(index, value, inputSource = "ClickableIntent") {
    //   let analyticsData = {name:value,type:'Quick Link' ,action:value,botid: "vYdoWvH2CVMbJOGnAB11VA=="}
    //   Axios.post(wrapperEndPoint.analyticsURL, analyticsData)
    //  // .then(response => response.data)
    //   .then(response => {
    //       console.log(response);//handle sucess
    //   }).catch(error => {
    //       console.log(error);//handle error
    //   });
    //   //
    //     if(inputSource=='quicklink') {
    //         this.setState({
    //             selectedQuickLink:index
    //         })
    //     }else{
    //         this.setState({
    //             selectedIndex: index
    //         })
    //     }
    //     this.setState(prevState => {
    //         return {
    //             chatMessages: [...prevState.chatMessages, {
    //                 message: value, timeStamp: TimeUtil.getCurrentTime(new Date()),
    //                 messageType: 'user', isFeedbackVisible: true, key: null, customInfos: {}
    //             }]
    //         }
    //     },()=>{
    //      this.getQuickLinkData(inputSource,value);
    //     })
  }

  /* Making Level Quick Link Structure */
  // getQuickLinkData(inputSource,value) {

  //    var data = QuickLinkData.data;

  //      let answer=''
  //      if (this.state.showWelcomeScreen) {
  //          this.setState({
  //              showWelcomeScreen: false
  //          })
  //      }
  //      //1st quick link and 3rd quick link

  //              //         answer='Please select one of these questions or type your query below<br/><br/>';
  //     //         data[this.state.selectedIndex].submenu.forEach((element, i) => {
  //     //             //answer+='<a href="javascript:autosubmit(\''+element.actionText+'\')">'+element.displayText+'</a>';
  //     //         });

  //      if(inputSource=="quicklink" && value=="Apply for New Products") {
  //          answer='Please select one of the options to continue or type your query below.<br/><br/>';
  //          data[0].category.forEach((element, i) => {

  //            answer+='<a href="javascript:autosubmit(\''+ element.actionText+'\')">'+element.displayText+'</a>';
  //          });

  //      }else if(inputSource=="quicklink" && value=="Balance and Statement") {
  //         answer='Please select one of the options to continue or type your query below.<br/><br/>';
  //         data[1].category.forEach((element, i) => {
  //           answer+='<a href="javascript:autosubmit(\''+ element.actionText+'\')">'+element.displayText+'</a>';
  //         });

  //     }

  //      this.addQuickLinkAnswer(answer);
  //  }
  //      /* Adding Quick Link Structure to server response */
  // addQuickLinkAnswer(msg) {
  //     var data = {
  //         "EntityName": "GenericQn: Hi, how can I help you today",
  //         "GenericResponse": true,
  //         "intentName": null,
  //         "intentID": null,
  //         "disamb": [],
  //         "entityID": null,
  //         "TimeStamp": "2019-04-15 14:28:56.888",
  //         "disambflag": false,
  //         "answer": msg,
  //         "extra": [],
  //         "promptLogin": false,
  //         "promptLogout": false,
  //         "isFeedbackVisible" : false,
  //         "WorkFlowflag": false,
  //         "nodeID": null,
  //         "key": '',
  //         "NonComprehendFlag": false,
  //         "errorFallbackLinks": "false"
  //     }
  //     this.addServerResponse(data);
  // }

  handleEntityName = (data) => {
    // DEV 28_08_25
    console.log(
      data.EntityName ||
        (data && data.extra && data.extra[0] && data.extra[0].entity) ||
        "SNP Plus"
    );
    this.setState({
      entityName:
        data.EntityName ||
        (data && data.extra && data.extra[0] && data.extra[0].entity) ||
        "SNP Plus",
    });
  };

  handleSubmit(
    chatInput,
    justApiCall = false,
    inputSource = "ClickableIntent",
    isFileData = false
  ) {
    /***
         *
         * 
         TODO: Handle the scroll and toggle based on this  (its bit tricky)
         
         */
    //isFeedbackEnable**
    let chatx = this.state.chatMessages;
    let value = 1;
    if (this.state.isPushBotVisible) {
      value = 2;
    }
    if (chatx.length >= value) {
      this.setState({
        isFeedbackEnable: true,
      });
    }

    let inputBarState = this.state.isInputDisabled;

    if (chatInput.includes("#ByUI#")) {
      let chat = this.state.chatMessages;
      let chatMsg = chat[chat.length - 1];
      let iframe =
        '<iframe width="100%" src="' +
        chatInput.split("#ByUI#")[1].trim() +
        '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
      this.addServerResponse(
        {
          ...chatMsg,
          errorFallbackLinks: this.props.data.quickLinksOnError,
          answer: iframe,
        },
        chatInput
      );
      return;
    }

    // QuickLinkData.data.forEach(array => {

    //     array.category.forEach(element => {

    //         if(element.actionText == chatInput && inputSource == 'typeInt'){
    //             let analyticsData = {name:chatInput,type:'Quick Link' ,action:chatInput, botid: "vYdoWvH2CVMbJOGnAB11VA=="}
    //          //   console.log(analyticsData);

    //             Axios.post(wrapperEndPoint.analyticsURL, analyticsData)
    //             .then(response => {
    //                 console.log(response);//handle sucess
    //             }).catch(error => {
    //                 console.log(error);//handle error
    //             });

    //         }

    //     });

    // });

    if (
      inputSource == "quicklink" ||
      (inputSource == "ClickableIntent" &&
        chatInput == "Govt ex-gratia interest scheme")
    ) {
      let analyticsData = {
        name: chatInput,
        type: "Quick Link",
        action: chatInput,
        botid: "vYdoWvH2CVMbJOGnAB11VA==",
      };

      Axios.post(wrapperEndPoint.analyticsURL, analyticsData)
        // .then(response => response.data)
        .then((response) => {
          console.log(response); //handle sucess
        })
        .catch((error) => {
          console.log(error); //handle error
        });
    }

    if (inputSource == "disamb") {
      inputSource = "RelatedQuestion";
    } else if (inputSource == "quicklink") {
      inputSource = "QuickLink";
    } else if (inputSource.toLowerCase() == "typeint") {
      inputSource = "ClickableIntent";
    }

    if (this.state.showWelcomeScreen) {
      this.setState({
        showWelcomeScreen: false,
      });
    }

    if (justApiCall === true) {
      this.handleApiResponse(true, chatInput, inputSource);
      return;
    }

    function handleChatInput() {
      if (!isNaN(chatInput) && chatInput.length === 16) {
        return chatInput.replace(/.(?=.{2})/g, "X");
      }
      if (chatInput.includes("#hideUserID#")) {
        var displayMsg = chatInput.split("#hideUserID#")[0];
        chatInput = chatInput.replace("#hideUserID#", "");
        return displayMsg;
      }

      if (chatInput.includes("<split>")) {
        var displayMsg = chatInput.split("<split>")[0];
        chatInput = chatInput.split("<split>")[1];
        return displayMsg;
      }
      //here otpMask

      if (inputBarState == false) {
        if (
          (
            document.querySelector(".sf-chatbot #chatInput") as HTMLInputElement
          ).classList.contains("sf-mask")
        ) {
          return chatInput.replace(/[a-zA-Z0-9.]/g, "X");
        }
      }

      return chatInput;
    }

    this.setState(
      (prevState) => {
        return {
          chatMessages: [
            ...prevState.chatMessages,
            {
              message: handleChatInput(),
              timeStamp: TimeUtil.getCurrentTime(new Date()),
              messageType: "user",
              isFeedbackVisible: true,
              key: null,
              customInfos: {},
            },
          ],
        };
      },
      () => {
        this.handleApiResponse(false, chatInput, inputSource, isFileData);
      }
    );
  }

  handleJustUIPrintCall(selectedItem) {
    this.setState((prevState) => {
      return {
        chatMessages: [
          ...prevState.chatMessages,
          {
            message: selectedItem,
            timeStamp: TimeUtil.getCurrentTime(new Date()),
            isFeedbackVisible: true,
            key: null,
            messageType: "user",
            customInfos: {},
          },
        ],
      };
    });
  }

  anchorTagColorChanger = (html) => {
    const fakeDiv = document.createElement("div");
    fakeDiv.innerHTML = html;

    const allAnchorTag = fakeDiv.getElementsByTagName("a") as any;
    for (let i = 0; i < allAnchorTag.length; i += 1)
      allAnchorTag[i].removeAttribute("style");

    return fakeDiv.innerHTML;
  };

  getUnifiedPersona = () => {
    let windowURL = window.location.href;
    let storeParam = windowURL.split("personacode=");
    if (storeParam[1]) return storeParam[1];
    else return "";
  };

  handleReturnChannel = () => {
    // DEV PREPROD 23-12-2024 PROD 27-12-2024
    if (window.location.href.includes("/pb/RBLCares/mobanklitepost")) {
      window["channel"] = "mobankpost";
    }
    if (window.location.href.includes("/pb/RBLCares/mobanklitepre")) {
      window["channel"] = "mobankpre";
    }
    if (window.location.href.includes("/pb/RBLCares/unifiedapppre")) {
      window["channel"] = "unifiedapppre";
    }
    if (window.location.href.includes("/pb/RBLCares/unifiedapppost")) {
      window["channel"] = "unifiedapppost";
    }
    if (window.location.href.includes("/pb/RBLCares/mycardpost")) {
      window["channel"] = "mycardpost";
    }
    if (window.location.href.includes("/pb/RBLCares/mycardpre")) {
      window["channel"] = "mycardpre";
    } else {
      window["channel"] = window["channel"];
    }
  };

  handleApiResponse = (
    justApiCall = false,
    chatInput,
    inputSource,
    isFileData = false
  ) => {
    // console.log("just", justApiCall);
    this.setState({
      apiCallWithoutInput: false,
    });
    if (this.state.uniqueUserId || !this.state.uniqueUserId) {
      this.appendLoader();
    }

    // commented to remove input disable condition for pb/..
    // if (this.state.isPushBotVisible == true) {
    //   //for pb/..
    //   // if (!window.location.href.includes("/pb/ccrew")) {
    //   this.disableInputBox(true);
    //   // }
    // }

    this.setState({ chatInput: "", chatInputDisplayValue: "" });
    var chatInputElement: HTMLInputElement = document.querySelector(
      ".sf-chatbot #chatInput"
    ) as HTMLInputElement;
    chatInputElement && chatInputElement.classList.remove("sf-mask");
    document.querySelector("#feedback-comment-box") &&
      document
        .querySelector("#feedback-comment-box")
        .parentElement.removeChild(
          document.querySelector("#feedback-comment-box")
        );
    var value = chatInput.replace(/ /g, "").toLowerCase();
    if (
      this.state.liveAgentData &&
      (value === "yes" || value == "banking" || value == "creditcard")
    ) {
      let key = this.state.liveAgentData.entityName
        .replace(/ /g, "")
        .toLowerCase();
      value = value == "yes" ? key : value;
      let agentEncryptedvalue =
        value == "creditcard"
          ? this.state.liveAgentData["creditCard"]
          : value == "banking"
          ? this.state.liveAgentData[value]
          : "";
      this.setState(
        {
          liveAgentData: {
            ...this.state.liveAgentData,
            agentType: agentEncryptedvalue,
          },
          showLiveAgentScreen: true,
        },
        () => {
          this.doHandOff(); //Live chat Handoff function
        }
      );
      this.disableActionLinks(true);
      this.removeLoader();
      return;
    }
    // this.toggleLoginScreen();

    //sending isPushbot flag to DataAPI**
    let isPushbot = "";
    if (this.state.isPushBotVisible == true) {
      isPushbot = "true";
    } else {
      isPushbot = "false";
    }
    let requestData: {
      q: any;
      channel: any;
      userInputSource: any;
      isPushbot: string;
      unifiedPersona?: string; // optional
    } = {
      q: encryptChatData(chatInput),
      channel: window["channel"], // dev
      userInputSource: inputSource,
      isPushbot: isPushbot,
    };

    if (
      window["channel"] === "unifiedapppre" ||
      window["channel"] === "unifiedapppost"
    ) {
      requestData.unifiedPersona = this.getUnifiedPersona();
    }

    DataAPI(isFileData)
      .post(
        "/chat", //chatapicall
        requestData
      )
      .then((response) => {
        this.setState({
          preLoginQuestion: "", // DEV 28_08_25
        });
        if (justApiCall) {
          this.setState({
            apiCallWithoutInput: true,
          });
        }
        if (response.data && response.data.isLoggedIn) {
          if (response.data.isLoggedIn) {
            // console.log("new-channel");
            if (
              window["channel"] === "mobankpre" ||
              window["channel"] === "mobankpost"
            ) {
              window["channel"] = "mobankbotlogin";
            } else if (
              window["channel"] === "mycardpre" ||
              window["channel"] === "mycardpost"
            ) {
              window["channel"] = "mycardbotlogin";
            } else if (
              window["channel"] === "unifiedapppre" ||
              window["channel"] === "unifiedapppost"
            ) {
              window["channel"] = "unifiedbotlogin";
            } else if (
              window["channel"] === "EBANKING"
            ) {
              window["channel"] = "ebankingpost";
            } else {
              window["channel"] = window["channel"];
            }
            console.log("channel is : ", window["channel"]);
          } else {
            // console.log("old-channel-1");
            this.handleReturnChannel();
          }
        } else {
          // console.log("old-channel-2");
          this.handleReturnChannel();
        }

        this.idleSessionTimeout();
        // response.data.answer = `<p>Here you go! The outstanding amount details of your card XXXXXXXXXXXXXX70</p> <p>Payment Due Date - 12/08/2025</p> <p>Total Amount Due - INR 107684.0</p> <p>Minimum Amount Due - INR 30944.00</p> <p>##ccPayment## JSONsplitter {"RedirectURL":"https://10.80.93.26/rblbnk/apNopd"} fallbackSplitter</p> <br><a class="Workflow-link" href="javascript:autosubmit('Payment Status')">Payment Status</a>`;
         //   response.data = {

      //     "EntityName": "Card\/Credit Card\/SplitnPay",
      
      //     "workflowRelatedQn": [],
      
      //     "GenericResponse": false,
      
      //     "intentName": null,
      
      //     "intentID": null,
      
      //     "disamb": [],
      
      //     "entityID": null,
      
      //     "workflowName": "Preclosure_SNP",
      
      //     "liveAgent": false,
      
      //     "TimeStamp": "2024-10-21 17:26:37.985",
      
      //     "disambflag": false,
      
      //     "promptLogout": false,
      
      //     "answer": "<p>Below is the list of EMIs. JSONsplitter {\"planCount\":\"plan\",\"workflow\":\"snpPreclosure\",\"snpPreclosure\":[{\"PlanBalance\":\"3600.00\",\"TransactionAmount\":\"3600.00\",\"SeqNo\":\"3\",\"Foreclosure\":\"3600.00\",\"PlanNo\":\"80024\",\"PlanOpenDt\":\"2024-09-30\",\"PlanDesc\":\"SALE NOT ON US DOM\",\"ReferenceNo\":\"20242741833046993414936\"},{\"PlanBalance\":\"4400.00\",\"TransactionAmount\":\"4400.00\",\"SeqNo\":\"4\",\"Foreclosure\":\"4400.00\",\"PlanNo\":\"80012\",\"PlanOpenDt\":\"2024-09-30\",\"PlanDesc\":\"SALE NOT ON US DOM\",\"ReferenceNo\":\"20242741834246943117402\"}]}&nbsp;<\/p>",
      
      //     "extra": [],
      
      //     "promptLogin": false,
      
      //     "isLoggedIn": true,
      
      //     "taskEnable": true,
      
      //     "WorkFlowflag": true,
      
      //     "taskName": "select plan",
      
      //     "nodeID": null,
      
      //     "key": 8137875,
      
      //     "NonComprehendFlag": false
      
      // }
        // response.data = {
        //     "EntityName": "Card\/Credit Card",
        //     "workflowRelatedQn": [],
        //     "GenericResponse": false,
        //     "intentName": null,
        //     "intentID": null,
        //     "disamb": [
        //         {
        //             "link": "<a href=\"javascript:autosubmit('How can I change my credit card bill date?')\">How can I change my credit card bill date?<\/a><br>\n"
        //         },
        //         {
        //             "link": "<a href=\"javascript:autosubmit('What is the process for settlement of dues on a Credit Card?')\">What is the process for settlement of dues on a Credit Card?<\/a><br>"
        //         }
        //     ],
        //     "entityID": null,
        //     "workflowName": null,
        //     "liveAgent": false,
        //     "TimeStamp": "2024-10-10 12:05:02.222",
        //     "disambflag": false,
        //     "promptLogout": false,
        //     "answer": "CMSsplitter {\"type\": \"cms\",\"link\":\"https:\/\/webassets.rbl.bank.in\/document\/txt\/FAQ318.txt\"} CMSendSplitter<i title='Question=How to close my Credit Card?'>   <\/i> \n",
        //     "extra": [
        //         {
        //             "question": "How to close my Credit Card?",
        //             "variationMatched": "<div>How can I close my RBL Bank Credit Card?",
        //             "reverseIntentScore": 1.0,
        //             "intentID": "43522",
        //             "entityID": "26437",
        //             "semantics": "<close> <credit card> <card> ",
        //             "intent": "Close",
        //             "semanticsequence": "<close> <methodenquiry> <rblbank> < Credit Card>",
        //             "entity_heirarchy": "Card > Credit Card",
        //             "intent_score": 1.0,
        //             "intent_notmatch": "All Matched",
        //             "entityinContext": "true",
        //             "reverseintent_notmatch": "All Matched",
        //             "nodeID": "89387",
        //             "entity": "Credit Card"
        //         }
        //     ],
        //     "promptLogin": false,
        //     "isLoggedIn": false,
        //     "taskEnable": false,
        //     "WorkFlowflag": false,
        //     "taskName": "",
        //     "nodeID": null,
        //     "key": 17358738,
        //     "NonComprehendFlag": false
        // }
        // response.data = {
        //     "EntityName": "EMI",
        //     "workflowRelatedQn": [],
        //     "GenericResponse": false,
        //     "intentName": "Apply",
        //     "intentID": "43511",
        //     "disamb": [],
        //     "entityID": "26495",
        //     "workflowName": "Card_snp",
        //     "liveAgent": false,
        //     "TimeStamp": "2024-09-02 17:16:36.467",
        //     "disambflag": false,
        //     "promptLogout": false,
        //     "answer": "<p>If you have not received it, please click on the option below. JSONsplitter { \"mask\" : true } fallbackSplitter &lt;br&gt;&nbsp;&nbsp;<\/p> <br><a class=\"Workflow-link\" href=\"javascript:autosubmit('Cancel')\">Cancel<\/a> <br><a class=\"Workflow-link\" href=\"javascript:autosubmit('Resend OTP')\">Resend OTP<\/a>",
        //     "extra": [],
        //     "promptLogin": false,
        //     "isLoggedIn": true,
        //     "taskEnable": true,
        //     "WorkFlowflag": true,
        //     "taskName": "OTP",
        //     "nodeID": "96410",
        //     "key": 8134210,
        //     "NonComprehendFlag": false
        // }
        // response.data.answer = "#helloMenu#";
        // response.data.answer = `<p>#NBdeeplink# JSONsplitter {\"deeplink\": \"https://mobanklite.rbl.bank.in/rbllite/Chatbot/Index?key=Check_Balance\"} fallbackSplitter Redirecting you to MoBank app...</p><i title='Question=How can I view my account balance?'>   </i> `
        // response.data =
        // {"EntityName":"","workflowRelatedQn":[{"link": "<a href=\"javascript:autosubmit('Know your required ATM location.')\">Search for ATMs at another location.</a>"},{"link": "<a href=\"javascript:autosubmit('Where is the nearest branch?')\">Where is the nearest branch?</a>"}],"GenericResponse":false,"intentName":null,"intentID":null,"disamb":[],"entityID":null,"workflowName":"","liveAgent":false,"TimeStamp":"2021-07-05 17:10:52.947","disambflag":false,"promptLogout":false,"answer":"<p>Here you go! The last transaction/s details of your Card ending &nbsp;XXXXXXXXXXXXXX39.<\/p>\n<p>&nbsp;JSONsplitter{\"workflow\":\"creditCardMiniStatement\",\"responseJson\":{\"creditCardMiniStatement\":[{\"amount\":\"499\",\"remarks\":\"PAYMENT RECEIVED - ELECTRONIC\",\"date\":\"24\/06\/2021\",\"type\":\"Credited\"},{\"amount\":\"49\",\"remarks\":\"PAYMENT RECEIVED - ELECTRONIC\",\"date\":\"19\/01\/2021\",\"type\":\"Credited\"},{\"amount\":\"49\",\"remarks\":\"PAYMENT RECEIVED - ELECTRONIC\",\"date\":\"19\/01\/2021\",\"type\":\" Debited\"},{\"amount\":\"433\",\"remarks\":\"PAYMENT RECEIVED - ELECTRONIC\",\"date\":\"09\/11\/2020\",\"type\":\"Credited\"}]}}endSplitter<\/p> What else can I help you with?#Logoless#","extra":[{"question":"How can I check if there is any debit on my Credit Card?","variationMatched":"How can I check if there is any debit on my Credit Card?","reverseIntentScore":1.0,"intentID":"48400","entityID":"26437","semantics":"","intent":"Check Debit","semanticsequence":"<check> <debited> <Credit Card>","entity_heirarchy":"Credit Card","intent_score":1.0,"intent_notmatch":"All Matched","entityinContext":"true","reverseintent_notmatch":"All Matched","nodeID":"96114","entity":"Credit Card"}],"promptLogin":false,"isLoggedIn":true,"taskEnable":false,"WorkFlowflag":false,"taskName":"transactionDetails","nodeID":null,"key":7976713,"NonComprehendFlag":false}
        // {"EntityName":"","workflowRelatedQn":[{"link": "<a href=\"javascript:autosubmit('Know your required ATM location.')\">Search for ATMs at another location.</a>"},{"link": "<a href=\"javascript:autosubmit('Where is the nearest branch?')\">Where is the nearest branch?</a>"}],"GenericResponse":false,"intentName":null,"intentID":null,"disamb":[],"entityID":null,"workflowName":"","liveAgent":false,"TimeStamp":"2021-07-05 17:10:52.947","disambflag":false,"promptLogout":false,"answer":'CMSsplitter {"type": "cms", "link": "https://d37h1lausy4x10.cloudfront.net/document/txt/FAQ165.txt"} CMSendSplitter endSplitter What else can I help you with?<i title="Question=How can I pay my Total Outstanding Amount?">   </i>#Logoless#',"extra":[{"question":"How can I check if there is any debit on my Credit Card?","variationMatched":"How can I check if there is any debit on my Credit Card?","reverseIntentScore":1.0,"intentID":"48400","entityID":"26437","semantics":"","intent":"Check Debit","semanticsequence":"<check> <debited> <Credit Card>","entity_heirarchy":"Credit Card","intent_score":1.0,"intent_notmatch":"All Matched","entityinContext":"true","reverseintent_notmatch":"All Matched","nodeID":"96114","entity":"Credit Card"}],"promptLogin":false,"isLoggedIn":true,"taskEnable":false,"WorkFlowflag":false,"taskName":"transactionDetails","nodeID":null,"key":7976713,"NonComprehendFlag":false}
        //  'Here you go! The last 5 credit transactions on your Card are JSONsplitter{"type":"string"}endSplitter  What else can I help you with?#Logoless#'
        // response.data = {
        //   EntityName: "Card/Credit Card",
        //   workflowRelatedQn: [],
        //   GenericResponse: false,
        //   intentName: null,
        //   intentID: null,
        //   disamb: [],
        //   entityID: null,
        //   workflowName: "CreditCard_OverduePayment",
        //   liveAgent: false,
        //   TimeStamp: "2025-08-19 18:48:22.625",
        //   disambflag: false,
        //   promptLogout: false,
        //   answer:
        //     '<p>Here you go! The outstanding amount details of your card XXXXXXXXXXXXXX55</p>\n<p>Payment Due Date - 07/22/2025</p>\n<p>Total Amount Due - 121200</p>\n<p>Minimum Amount Due - 12000</p>\n<p>##ccPayment## JSONsplitter {"RedirectURL":"https:\\/\\/10.80.93.26\\/s\\/apNoDJ"} fallbackSplitter </p> <br><a class="Workflow-link" href="javascript:autosubmit(\'Payment Status\')">Payment Status</a>',
        //   extra: [],
        //   promptLogin: false,
        //   isLoggedIn: true,
        //   taskEnable: true,
        //   WorkFlowflag: true,
        //   taskName: "Details",
        //   nodeID: null,
        //   key: 8168799,
        //   NonComprehendFlag: false,
        // };
        if (!!response.data) {
          if (
            chatInput.includes("Thanks! I'm good") ||
            chatInput.includes("I'm done")
          ) {
            response.data.answer = response.data.answer + " 👍";
          }
          // if(response.data.answer.indexOf('$AUTOTRIGGERQUERY') > -1){
          //     const parts = response.data.answer.split("~");
          //     console.log(parts[1]);
          //     this.handleSubmit(parts[1], true);
          // }
          // response.data.answer = this.anchorTagColorChanger(response.data.answer);
          if (response.data.answer.indexOf("<p>#NewBubble#</p>") !== -1) {
            let responses = response.data.answer.split("<p>#NewBubble#</p>");

            // responses.map((e)=>{
            //     response.data.answer=e;
            //     this.addServerResponse({ ...response.data, errorFallbackLinks: this.props.data.quickLinksOnError }, chatInput);
            // })
            if (
              response.data.workflowName === "upgradelimit" ||
              response.data.workflowName === "RBL_Upgradecard" ||
              response.data.workflowName === "KYC_Appoitment_bot" ||
              response.data.workflowName === "Upload_KYC_Documents" ||
              response.data.workflowName === "Chatbot_lifeinsurance" ||
              response.data.workflowName === "RBL_HDFCHealthInsurance"
            ) {
              let iteration = 0;
              let timeout = setInterval(() => {
                if (iteration > responses.length - 1) {
                  clearInterval(timeout);
                  return;
                }
                response.data.answer = responses[iteration];
                this.addServerResponse(
                  {
                    ...response.data,
                    errorFallbackLinks: this.props.data.quickLinksOnError,
                  },
                  chatInput
                );
                iteration = iteration + 1;
              }, 3000);
            } else {
              responses.map((e) => {
                response.data.answer = e;
                this.addServerResponse(
                  {
                    ...response.data,
                    errorFallbackLinks: this.props.data.quickLinksOnError,
                  },
                  chatInput
                );
              });
            }
          } else if (response.data.answer.includes('type": "cms"')) {
            //cms**

            //  console.log(response.data.answer);

            var cmsData1 = response.data.answer.split(/CMSsplitter /)[1];
            //  console.log(cmsData1)

            var cmsData = JSON.parse(cmsData1.split(/ CMSendSplitter/)[0]);
            var splitbubble = cmsData1.split(/ CMSendSplitter/)[1];
            var url = cmsData.link;

            this.setState({
              cmsURL: url,
            });

            //  console.log("cmsData: ",cmsData);

            Axios.get(url).then(
              (cmsresponse) => {
                // console.log(cmsresponse.data);
                response.data.answer =
                  splitbubble && splitbubble.includes("endSplitter")
                    ? "<div>" + cmsresponse.data + "</div>" + splitbubble
                    : "<div>" + cmsresponse.data + "</div>";
                // response.data.answer =  '<div><div>Please click<a target="_blank" href="http://bit.ly/2Kc7zDy" class="sf-extlnk class">here</a> and watch the video to know how to read your RBL Bank Credit Card statement. You can also <a target="_self" href="javascript:autosubmit(\'How can I download my credit card statement?\')" class="sf-asbmt class" data-linktype="asbmt">login</a> here to view and download your statement.</div><div><br></div><div>Alternatively, you can view your statement and make your Card payment using RBL MyCard Mobile App. <a target="_blank" href="http://onelink.to/389ejv" class="sf-extlnk class">Download</a> now!</div><div><br></div><div><div>I can also help explain the important details mentioned in your monthly Credit Card statement. What would you like to know about?</div><div><div class="action-elem" onclick="javascript:autosubmit(\'What is the statement cycle of my Credit Card?\')" >Statement Date</div></div><div><div class="action-elem" onclick="javascript:autosubmit(\'What is my Statement Period?\')" >Statement Period</div></div><div><div class="action-elem" onclick="javascript:autosubmit(\'I want to know about Payments and Credits\')" >Payments and Credits</div></div><div><div class="action-elem" onclick="javascript:autosubmit(\'Tell me about New Purchases\')" >New Purchases</div></div></div><div><div class="action-elem" onclick="javascript:autosubmit(\'What is Total Outstanding Amount?\')" >Total Amount Due</div></div><div><div class="action-elem" onclick="javascript:autosubmit(\'What is my Last Bill Amount?\')" >Last Bill Amount</div></div><div><div class="action-elem" onclick="javascript:autosubmit(\'What is Minimum Amount Due?\')" >Minimum Payment Due</div></div><i title=\'Question=How to read Credit Card Statement?\'></i></div>';
                this.addServerResponse(
                  {
                    ...response.data,
                    errorFallbackLinks: this.props.data.quickLinksOnError,
                  },
                  chatInput
                );
              },
              (error) => {
                var offlineMessage = `Something went wrong. Please try again later.`;
                this.addServerResponse(
                  {
                    answer: offlineMessage,
                    errorFallbackLinks: this.props.data.quickLinksOnError,
                  },
                  chatInput
                );
                console.log(error);
              }
            );
          } else if (
            response.data.NonComprehendFlag ||
            response.data.answer.includes("#menu#") ||
            response.data.answer.includes("#helloMenu#") || // UAT 11_07_25 PREPROD 30_07_25 PROD 04_08_25
            response.data.answer.includes("Please choose an option:")
            // || response.data.EntityName === "SelfIntroductionEntity" // UAT 19_06_25
          ) {
            //CNCLinks -->

            Axios.get(wrapperEndPoint.CNCLinksURL, { withCredentials: false })
              .then((JSONresponse) => {
                let filteredCategories = [];
                if (
                  response.data.answer.includes("#helloMenu#") ||
                  response.data.answer.includes("Please choose an option:")
                ) {
                  // UAT 19_06_25 11_07_25
                  filteredCategories = JSONresponse.data.filter((item) =>
                    [
                      "Apply for New Products",
                      "Credit Card Services",
                      "Banking Services",
                    ].includes(item.category)
                  );
                  this.setState({ CNCLinksData: filteredCategories });
                } else this.setState({ CNCLinksData: JSONresponse.data });

                let CNCLinksResponse = "";

                if (response.data.NonComprehendFlag) {
                  // UAT 19_06_25
                  //when NonComprehendFlag is true (could not understand)

                  CNCLinksResponse =
                    response.data.answer +
                    `${JSONresponse.data // UAT 19_06_25
                      .map((item, i) => {
                        return (
                          '<div class="action-elem" onClick="javascript:autoCNClinksubmit(\'' +
                          item.category +
                          "','" +
                          i +
                          "')\">" +
                          item.category +
                          "</div>"
                        );
                      })
                      .join("")}`;
                }

                if (response.data.answer.includes("#menu#")) {
                  // when menu, option, main menu etc, based on #menu# flag

                  CNCLinksResponse =
                    "<div>Here are a few options. Please select one to continue or type your query below.</div><br>" +
                    `${JSONresponse.data
                      .map((item, i) => {
                        return (
                          '<div class="action-elem" onClick="javascript:autoCNClinksubmit(\'' +
                          item.category +
                          "','" +
                          i +
                          "')\">" +
                          item.category +
                          "</div>"
                        );
                      })
                      .join("")}`;
                }

                if (
                  response.data.answer.includes("#helloMenu#") ||
                  response.data.answer.includes("Please choose an option:")
                ) {
                  // UAT 19_06_25 PREPROD 30_07_25 PROD 04_08_25
                  CNCLinksResponse =
                    "Hi, How can we help you today? Please choose an option:" +
                    `${filteredCategories // UAT 19_06_25
                      .map((item, i) => {
                        return (
                          '<div class="action-elem" onClick="javascript:autoCNClinksubmit(\'' +
                          item.category +
                          "','" +
                          i +
                          "')\">" +
                          item.category +
                          "</div>"
                        );
                      })
                      .join("")}`;
                }

                this.addServerResponse(
                  {
                    answer: CNCLinksResponse,
                    liveAgent: response.data.liveAgent,
                    liveAgentData: response.data.liveAgentData,
                  },
                  chatInput
                );

                // {answer: CNCLinksResponse }
              })
              .catch((error) => {
                var offlineMessage = `Something went wrong. Please try again later.`;
                this.addServerResponse({ answer: offlineMessage }, chatInput);
                console.log(error);
              });
          } else {
            this.addServerResponse(
              {
                ...response.data,
                errorFallbackLinks: this.props.data.quickLinksOnError,
              },
              chatInput
            );
          }
        }
      })
      .catch((error) => {
        var offlineMessage = `I'm currently not available to chat, due to routine maintenance. Please come back later, and I'd be happy to help you`;
        if (justApiCall) {
          this.setState({
            apiCallWithoutInput: true,
          });
        }
        this.addServerResponse(
          {
            answer: offlineMessage,
            errorFallbackLinks: this.props.data.quickLinksOnError,
          },
          chatInput
        );

        console.log(error);
      });
  };

  handleCNCLinksClick(selectedItem, i) {
    console.log(selectedItem, i);

    // if (window.location.href.includes("pb/")) {
    //   window["autosubmit"](selectedItem);
    //   return;
    // }

    let submenuArray = this.state.CNCLinksData[i].submenu;

    if (submenuArray.length > 1) {
      this.setState((prevState) => {
        return {
          chatMessages: [
            ...prevState.chatMessages,
            {
              message: selectedItem,
              timeStamp: TimeUtil.getCurrentTime(new Date()),
              isFeedbackVisible: true,
              key: null,
              messageType: "user",
              customInfos: {},
            },
          ],
        };
      });
    }
    if (submenuArray.length > 1) {
      let subResponse =
        "<div>Please select one of the options to continue or type your query below.</div>" +
        `<div>${submenuArray
          .map((item, j) => {
            return (
              '<div class="action-elem" onClick="javascript:autosubmit(\'' +
              item.actionText +
              "','" +
              j +
              "')\">" +
              item.displayText +
              "</div>"
            );
          })
          .join("")}</div>`;
      this.addServerResponse({ answer: subResponse });
    } else if (
      submenuArray.length == 1 &&
      !submenuArray[0].displayText.includes("overlay")
    ) {
      let inputString =
        submenuArray[0].actionText + "<split>" + submenuArray[0].actionText;
      window["autosubmit"](inputString);
    } else if (
      submenuArray.length == 1 &&
      submenuArray[0].displayText.includes("overlay")
    ) {
      let str = submenuArray[0].displayText;
      var lastIndex = str.lastIndexOf(" ");
      str = str.substring(0, lastIndex);

      // console.log(document.getElementById("ql_" + str));

      document.getElementById("ql_" + str).click();
    }
  }

  doHandOff = () => {
    let length = this.state.chatMessages.length;
    let chatKey = this.state.chatMessages[length - 2].key;
    //Api call for counting Live Chat Handoff
    DataAPI()
      .post("/dohandoff", {
        key: chatKey,
      })
      .catch((error) => {
        console.log(error);
      });
  };

  disableInputBox(isDisable = false) {
    this.setState(
      {
        isInputDisabled: isDisable,
      },
      () => {
        let event;
        if (typeof Event === "function") {
          event = new Event("resize");
        } else {
          event = document.createEvent("Event");
          event.initEvent("resize", true, true);
        }
        window.dispatchEvent(event);

        //   window.dispatchEvent(new Event('resize'));
      }
    );
  }

  disableActionLinks = (liveAgent = false) => {
    var editButton = document.querySelectorAll(".each-edit");
    if (editButton.length != 0) {
      editButton.forEach((editbutton) => {
        //editbutton.classList.add('disabled');
        editbutton.classList.add("edit-action-elem");
        //editbutton.classList.add('each-edit');
      });
    }

    var elements = document.querySelectorAll(
      ".msg-server-wrapper:not(.sf-options):not(.disamb) .msg-server"
    );

    elements = Array.prototype.slice.call(elements);

    elements.forEach((element, i) => {
      if (
        (i !== elements.length - 1 &&
          (element.classList.contains("WorkFlow") ||
            element.classList.contains("liveAgent"))) ||
        liveAgent
      ) {
        Array.prototype.slice
          .call(element.querySelectorAll(".action-elem,.disable-item"))
          .forEach((actionElem) => {
            actionElem.classList.add("disabled");
            // if(editButton.length disableActionLinks!= 0){

            //     editButton.forEach((editbutton)=>{
            //         //    editbutton.classList.add('disabled');
            //         editbutton.classList.add('disabledEditButton');
            //         })
            // }
          });
      } else if (i != elements.length - 1) {
        Array.prototype.slice
          .call(element.querySelectorAll(".login-button"))
          .forEach((actionElem) => {
            actionElem.classList.add("inactive");
          });
      }
    });
  };

  getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        this.setLocationValues,
        this.showError
      );
    } else {
      showSnackBar("Geolocation is not supported by this browser");
    }
  };

  setLocationValues = (position) => {
    // $("#chat_div").chatbox("option", "boxManager").addMsg('AIRA', "Getting results using your GPS location");
    // userLocationDetails = {
    //     lat : position.coords.latitude,
    //     long : position.coords.longitude
    // }
    // autosubmit(JSON.stringify(userLocationDetails));
    var userLocationDetails =
      position.coords.latitude + "," + position.coords.longitude;
    this.removeLoader();
    window["autosubmit"](userLocationDetails, true);
  };

  showError = (error) => {
    this.removeLoader();
    switch (error.code) {
      case error.PERMISSION_DENIED:
        window["autosubmit"](this.userQuestionStored, true);
        break;
      case error.POSITION_UNAVAILABLE:
        window["autosubmit"](this.userQuestionStored, true);
        break;
      case error.TIMEOUT:
        window["autosubmit"](this.userQuestionStored, true);
        break;
      case error.UNKNOWN_ERROR:
        window["autosubmit"](this.userQuestionStored, true);
        break;
    }
  };

  mdToJSON(md) {
    //var reg = MDUtil.linkRegex;
    //regex lastIndex stupidity with //g so have declared a local
    var res = /#_#.?{(.*?)}.?{(.*?)}.?{(.*?)}/.exec(md);
    //SPUPID format below
    var obj = { Type: "disamb", actionText: res[2], displayText: res[3] };

    return obj;
  }

  getArrayFromLinkText(links) {
    return links.map((e) => {
      return this.mdToJSON(MDUtil.convertAutoSubmitHtmlToSFMarkdown(e.link));
    });
  }

  changeChatMessages = (val) => {
    let chatMessages = this.state.chatMessages.map((item) => {
      var { message } = item;
      if (message.includes(val) && message.includes("<JSONsplitter>")) {
        item.message = message.split("<JSONsplitter>")[0];
      } else if (message.includes(val) && message.includes("JSONsplitter")) {
        item.message = message.split("JSONsplitter")[0];
      }
      return item;
    });
    this.setState({ chatMessages });
  };

  handleLogout = (logoutUser) => {
    this.setState({ logoutUser });
  };
  numberOnlyEnable(isDisable = false) {
    this.setState({
      numbersOnly: isDisable,
    });
  }

  redirectToMyCard = (myCardData) => {
    let myCardRedirectURL = myCardData;

    setTimeout(function () {
      window.location.href = myCardRedirectURL;
    }, 5000); //7000
  };

  redirectToMoBank = (moBankData) => {
    let redirect_url;

    // redirect_url =
    //   "https://mobanklitetest.rbl.bank.in/rbllite/Chatbot/Index?key=" +
    //   moBankData; //dev
    redirect_url =
      "https://mobanklite.rbl.bank.in/rbllite/Chatbot/Index?key=" + moBankData; //prod

    //console.log(redirect_url);
    // data.answer = "<div>Redirecting you to MoBank app...</div>"
    // console.log(data.answer);
    // data.promptLogin=false;

    this.setState({
      moBankAppsuggestionsFlag: true, //suggestions off
    });
    setTimeout(function () {
      window.location.href = redirect_url;
    }, 4000); //7000
  };

  redirectToNB = (NBData) => {
    console.log(NBData);

    if (document.getElementById(NBData) !== null) {
      setTimeout(function () {
        document.getElementById(NBData).click();
      }, 4000);
    }
  };

  addServerResponse = (data, chatInput = "") => {
    let {
      promptLogout: logoutUser,
      isLoggedIn,
      workflowName,
      liveAgent,
      liveAgentData,
      taskName,
    } = data;
    let logoutFirst = false;
    let middleLogin = false;

    //    if(this.props.netbanking && data.extra[0].entity == "Customer Care" && data.extra[0].intent == "Connect"){
    //    // console.log(data.extra[0].entity,data.extra[0].intent, this.props.netbanking)
    //     data.promptLogin=true;
    //   //  console.log(data.promptLogin)
    //    }

    this.setState({
      setWorkflowName: workflowName,
    });

    if (workflowName == "CrestDebitCard" && data.WorkFlowflag == true) {
      // new**

      this.setState({ isCrestDebitCardFlow: true });
    } else {
      this.setState({ isCrestDebitCardFlow: false });
    }

    if (
      (data.taskName === "Intro" ||
        data.taskName === "checkLoginMode" ||
        data.taskName === "get card number" ||
        (window.location.href.indexOf("pb/stpl") > -1 &&
          data.EntityName == "Credit Card/CreditCardSTPL")) &&
      !!this.state.uniqueUserId
    ) {
      this.handleApiResponse(
        false,
        this.state.uniqueUserId,
        "ClickableIntent",
        false
      );
      return;
    }

    if (liveAgent) {
      data.answer = liveAgentData.promptMessage;

      this.setState({
        // showLiveAgentScreen : liveAgent,
        liveAgentData,
      });
    } else {
      this.setState({
        showLiveAgentScreen: liveAgent,
        liveAgentData: "",
      });
    }

    if (logoutUser) {
      this.setState({ logoutUser });
      return;
    }

    this.setState({ isLoggedIn });
    if (isLoggedIn) {
      // if(this.props.netbanking){ //resetNB
      //     window["resetSessionVar"]();
      // }
      this.startSessionTimeout();
      this.disableInputBox(false); //disable i/p
      isInsignia();
    } else {
      this.disableInputBox(false);
    }
    // if(!data.WorkFlowflag) {
    //     this.disableInputBox(true);
    // }

    var answer = data.responseElements ? data.responseElements : data.answer;
    var disamb = data.disamb ? this.getArrayFromLinkText(data.disamb) : null;

    if (Boolean(data.disambQuestions) && data.disambQuestions.length > 0) {
      disamb = data.disambQuestions;
    } else if (
      Boolean(data.relatedQuestions) &&
      data.relatedQuestions.length > 0
    ) {
      disamb = data.relatedQuestions;
    } else if (Boolean(data.suggestions) && data.suggestions.length > 0) {
      disamb = data.suggestions;
    }

    if (
      data.hasOwnProperty("workflowRelatedQn") &&
      data.workflowRelatedQn.length > 0
    ) {
      disamb = this.getArrayFromLinkText(data.workflowRelatedQn);
    }
    var errorFallbackLinks = data.errorFallbackLinks || false;

    if (data.NonComprehendFlag == true && errorFallbackLinks == true) {
      //Show quick links only when CouldNotComprehend
      errorFallbackLinks = true;
    }

    if (this.state.isPushBotVisible) {
      data.isPushbot = "true";
    } else {
      data.isPushbot = "false";
    }

    //crest** promotion

    if (data.eligibleCrest == true) {
      //flag
      this.setState({
        eligibleCrest: true,
      });
    }

    if (data.firstWorkflow == true) {
      //flag
      this.setState({
        firstWorkflow: true,
      });
    }

    //first workflow is not crest flow
    if (workflowName == "CrestDebitCard") {
      this.setState({
        eligibleCrest: false,
      });
    }
    //CASE1
    if (this.state.eligibleCrest == true && this.state.firstWorkflow == false) {
      this.setState({
        isOverlayPopUpVisible: true,
        eligibleCrest: false,
        overlayPopUpData: {
          popupType: "Crest",
          image: CrestGIF,
          title: "Congratulations!",
          subTitle: "",
          description:
            "You can now upgrade to Crest Debit Card and get full value Shopping Vouchers worth INR 1500 and much more!!",
          inputString1: "I want to apply for Crest debit card.",
          option1: "Apply Now",
        },
      });
    }
    //line 1339

    //eligibleDeposit promotion
    if (data.eligibleDeposit == true) {
      //flag
      this.setState({
        eligibleDeposit: true,
      });
    }

    //CASE1

    if (
      this.state.eligibleDeposit == true &&
      this.state.firstWorkflow == false &&
      this.state.loginOpenFDFlag == true
    ) {
    } else if (
      this.state.eligibleDeposit == true &&
      this.state.firstWorkflow == false
    ) {
      /// to test**

      this.setState({
        isOverlayPopUpVisible: true,
        eligibleDeposit: false,
        overlayPopUpData: {
          popupType: "Deposit",
          image: DepositImage,
          title: "",
          subTitle: "Want to grow your money?",
          description:
            "Just open a Term Deposit with us and earn attractive returns!!",
          inputString1: "Apply for a deposit account",
          option1: "Apply Now",
        },
      });
    }

    if (answer.includes("&nbsp;")) {
      ///&nbsp;/g, ''
      answer = answer.replace(/&nbsp;/g, " ");
    }
    if (answer.includes("#NewBubble#")) {
      answer = answer.replace("#NewBubble#", "");
    }

    if (answer.includes("##rewards##")) {
      answer = answer.replace("##rewards##", "");

      let rewardsData = data.answer.split("JSONsplitter")[1];
      rewardsData = rewardsData.split("fallbackSplitter")[0];
      rewardsData = JSON.parse(rewardsData);
      //  console.log(rewardsData)

      this.setState({
        rewardsDataJson: rewardsData,
      });

      answer =
        answer +
        `<div class="action-elem" onClick="javascript:rewardURLcall()" >Proceed</div>`;
    }

    // ##ccPayment## UAT 21_08_25

    if (answer.includes("##ccPayment##")) {
      answer = answer.replace("##ccPayment##", "");

      let ccPayment = data.answer.split("JSONsplitter")[1];
      ccPayment = ccPayment.split("fallbackSplitter")[0];
      ccPayment = JSON.parse(ccPayment);

      let answerHtml = answer.split("JSONsplitter")[0];
      const openPTags = (answerHtml.match(/<p[^>]*>/g) || []).length;
      const closePTags = (answerHtml.match(/<\/p>/g) || []).length;
      if (openPTags > closePTags) {
        answerHtml += "</p>";
      }
      if (ccPayment && ccPayment.RedirectURL) {
        const statusBtnId = `check-status-${Date.now()}-${Math.floor(
          Math.random() * 10000
        )}`;
        answer =
          answerHtml +
          `<a class="action-elem" id="pay-now-btn" href="${ccPayment.RedirectURL}" target="_blank">Pay Now</a>` +
          `<a class="action-elem disabled" id="${statusBtnId}" href="javascript:autosubmit('Payment Status')">Payment Status</a>`;

        // Enable the "Payment Status" button after 180 seconds (3 minutes)
        setTimeout(() => {
          const enablePaymentStatus = () => {
            const statusBtn = document.getElementById(statusBtnId);
            console.log(statusBtn.classList);
            if (statusBtn && statusBtn.classList.contains("disabled")) {
              statusBtn.classList.remove("disabled");
            }
          };
          // Try immediately, and also in case the DOM isn't ready, retry a few times
          let tries = 0;
          const interval = setInterval(() => {
            enablePaymentStatus();
            tries++;
            if (
              document.getElementById(statusBtnId) &&
              !document
                .getElementById(statusBtnId)
                .classList.contains("disabled")
            ) {
              clearInterval(interval);
            }
            if (tries > 10) clearInterval(interval);
          }, 500);
          enablePaymentStatus();
          console.log("Payment Status button enabled");
        }, 180000); // 180000 ms = 3 minutes

        // Disable the "Pay Now" button once clicked and redirect
        setTimeout(() => {
          const payNowBtn = document.getElementById("pay-now-btn");
          if (payNowBtn) {
            payNowBtn.addEventListener("click", function (e) {
              payNowBtn.classList.add("disabled");
              // Optionally, prevent multiple clicks
              payNowBtn.setAttribute("disabled", "true");
              // Let the default action (redirection) proceed
            });
          }
        }, 0);
      } else {
        answer = answerHtml;
      }
    }

    //#rewardCalender#

    if (answer.includes("#rewardCalender#")) {
      answer = answer.replace("#rewardCalender#", "");
      this.setState({
        showRewardCalender: true,
      });
    } else {
      this.setState({
        showRewardCalender: false,
      });
    }

    if (answer.includes("checkBox")) {
      //  answer = answer.replace("##checkBox##","");
      //             "tcCheckBox": "true",
      // "tcText":"Yes, I agree with the Terms and Conditions",
      // "tcCheckBoxDefault":"false"

      let checkBoxData = data.answer.split("JSONsplitter")[1];
      checkBoxData = checkBoxData.split("fallbackSplitter")[0];
      checkBoxData = JSON.parse(checkBoxData.replace(/&nbsp;/g, ""));

      this.setState({
        checkBoxJsonData: checkBoxData.text,
        checkBoxFlag: checkBoxData.checkBox,
        termsCheckBox: checkBoxData.tcCheckBox,
        termsCheckBoxFlag: checkBoxData.tcCheckBoxDefault,
        termsText: checkBoxData.tcText,
        termsLink: checkBoxData.tcLink,
      });
    }

    //##rekycBanking## JSONsplitter { "ref" : "", "type" :  }
    if (answer.includes("##rekycBanking##")) {
      answer = answer.replace("##rekycBanking##", "");

      let rekyc_jsonData = answer.split("JSONsplitter")[1];
      rekyc_jsonData = rekyc_jsonData.split("fallbackSplitter")[0];

      rekyc_jsonData = JSON.parse(rekyc_jsonData); //string to object

      //false->mbr  and true->mbi

      var refID = rekyc_jsonData.ref;

      if (rekyc_jsonData.type == false) {
        this.setState({
          // rekycBankingData: {
          //   flag: true,
          //   url:
          //     "https://rekyccloud.rbl.bank.in/Rekyc/#/login?ref=" +
          //     rekyc_jsonData.ref +
          //     "&type=mbr&channel=chatbot",
          // }, //dev
          rekycBankingData: {
            flag: true,
            url:
              "https://rekyc.rbl.bank.in/Rekyc/#/login?ref=" +
              rekyc_jsonData.ref +
              "&type=mbr&channel=chatbot", //pre-prod & prod
          },
        });
      } else if (rekyc_jsonData.type == true) {
        this.setState({
          // rekycBankingData: {
          //   flag: true,
          //   url:
          //     "https://rekyccloud.rbl.bank.in/Rekyc/#/login?ref=" +
          //     rekyc_jsonData.ref +
          //     "&type=mbi&channel=chatbot",
          // }, //dev
          rekycBankingData: {
            flag: true,
            url:
              "https://rekyc.rbl.bank.in/Rekyc/#/login?ref=" +
              rekyc_jsonData.ref +
              "&type=mbi&channel=chatbot",
          }, //prod & preprod
        });
      }
    }

    //

    if (answer.includes("##disableBar##")) {
      this.disableInputBox(true);
      answer = answer.replace("##disableBar##", "");
    }

    if (answer.includes("#SFlocation")) {
      this.userQuestionStored = chatInput;
      this.getLocation();
      return;
    }

    if (answer.includes("#ImagePath#")) {
      answer = '<div class="imagePointer">' + answer + "</div>";
    }

    // //hideBoxForPushbot
    if (
      answer.includes("#hideBoxForPushbot#") &&
      this.state.isPushBotVisible == true
    ) {
      answer = answer.replace("#hideBoxForPushbot#", "");
      //   console.log("here")
      this.disableInputBox(true); //hide i/p
    } else {
      answer = answer.replace("#hideBoxForPushbot#", "");
    }

    if (answer.includes("#MiddleLogin#")) {
      answer = answer.replace("#MiddleLogin#", "");
      middleLogin = true;
    }
    if (answer.includes("##SHOWLOGIN##")) {
      answer = answer.replace("##SHOWLOGIN##", "");
      logoutFirst = true;
      if (data.EntityName == "") {
        // dev 20_12_24 // PREPROD 23-12-24 PROD 27-12-2024
        if (data.extra && data.extra[0] && data.extra[0].entity) {
          data.EntityName = data.extra[0].entity;
        }
      }
    }

    //##loginOpenFD##
    if (answer.includes("##loginOpenFD##")) {
      answer = answer.replace("##loginOpenFD##", "");
      logoutFirst = true;
      //console.log(data.EntityName);
      // console.log(data.extra[0].entity);
      this.setState({
        loginOpenFDFlag: true,
      });

      if (data.EntityName == "") {
        if (data.extra && data.extra[0] && data.extra[0].entity) {
          data.EntityName = data.extra[0].entity;
        }
        //console.log(data.EntityName);
      }
      this.setState({
        preLoginQuestion: "I want to open a Fixed Deposit account.",
      });
    }

    //##loginOpenRD##

    if (answer.includes("##loginOpenRD##")) {
      answer = answer.replace("##loginOpenRD##", "");
      logoutFirst = true;
      //console.log(data.EntityName);
      // console.log(data.extra[0].entity);

      if (data.EntityName == "") {
        if (data.extra && data.extra[0] && data.extra[0].entity) {
          data.EntityName = data.extra[0].entity;
        }
        //console.log(data.EntityName);
      }
      this.setState({
        preLoginQuestion: "I want to open a Recurring Deposit account.",
      });
    }

    // #loginStpl# - Apply for STPL
    if (answer.includes("#loginStpl#") || answer.includes("#loginSnpPlus#")) {
      answer = answer.replace("#loginStpl#", "");
      answer = answer.replace("#loginSnpPlus#", "");
      logoutFirst = true;
      this.setState({
        loginSTPLFlag: true,
      });
      if (data.EntityName == "") {
        if (data.extra && data.extra[0] && data.extra[0].entity) {
          data.EntityName = data.extra[0].entity;
        }
        //console.log(data.EntityName);
      }
      if (answer.includes("#loginStpl#")) {
        this.setState({
          preLoginQuestion: "Apply for STPL",
        });
      } else {
        //for SnpPlus
        this.setState({
          preLoginQuestion: "How can I book split N pay plus",
        });
      }
    }

    // #loginXcash# - I want to apply for Xpress Cash.
    if (answer.includes("#loginXcash#")) {
      answer = answer.replace("#loginXcash#", "");
      logoutFirst = true;
      this.setState({
        loginXcashFlag: true,
      });
      if (data.EntityName == "") {
        if (data.extra && data.extra[0] && data.extra[0].entity) {
          data.EntityName = data.extra[0].entity;
        }
        //console.log(data.EntityName);
      }
      this.setState({
        preLoginQuestion: "I want to apply for Xpress Cash.",
      });
    }

    // #loginLRSF# - How can I transfer funds quickly and easily with RBL bank outward remittance?
    if (answer.includes("#loginLRS#")) {
      answer = answer.replace("#loginLRS#", "");
      logoutFirst = true;
      this.setState({
        loginLRSFlag: true,
      });
      if (data.EntityName == "") {
        if (data.extra && data.extra[0] && data.extra[0].entity) {
          data.EntityName = data.extra[0].entity;
        }
        console.log(data.EntityName);
      }
      this.setState({
        preLoginQuestion:
          "How can I transfer funds quickly and easily with RBL bank outward remittance?",
      });
    }

    //##LiveChatWF && /pb/RBLCares/mobanklitepre/post

    if (
      answer.includes("#LiveChatWF#") &&
      (window.location.href.includes("/pb/RBLCares/mobanklitep") ||
        window.location.href.includes("/pb/RBLCares/mycardp") ||
        this.props.netbanking)
    ) {
      answer = answer.replace("#LiveChatWF#", "");
      logoutFirst = true;
      // console.log(data.extra[0].entity);

      if (data.extra && data.extra[0] && data.extra[0].entity) {
        data.EntityName = data.extra[0].entity;
      }
      //console.log(data.EntityName);

      if (data.extra && data.extra[0] && data.extra[0].entity == "callback") {
        //entity:"callback",intent:"want"
        this.setState({
          preLoginQuestion: "I want to opt for callback.",
        });
      }
      if (
        data.extra &&
        data.extra[0] &&
        data.extra[0].entity == "Customer Care"
      ) {
        // entity:"Customer Care",intent:"Connect"
        this.setState({
          preLoginQuestion: "Can you connect me to customer care?",
        });
      }
    }

    //Sure! You can chat for further assistance.Please login to continue.

    if (answer.includes("##LoginNotRequried##")) {
      answer = answer.replace("##LoginNotRequried##", "");
      data.promptLogin = false;
    }
    if (answer.includes("##DisableLoginForEdu##")) {
      answer = answer.replace("##DisableLoginForEdu##", "");
      data.promptLogin = false;
      disamb = null;
    }
    // if(data.handoffToAgent == true ){
    //   answer = "Comming soon ! \n Please find below quick links for other help ! " //Connecting to agent
    //   errorFallbackLinks = true
    // }
    this.removeLoader();
    var endMessage = "";
    // var extra_question = '';
    var remainingMessage = "";
    var jsonData = "";
    var endDisamb = "";
    try {
      //disable i/p
      // if(answer.includes('liabilitiesGetAuthenticators')) {
      //     this.setState({
      //         isInputDisabled: true
      //     })
      // }else{
      //     this.setState({
      //         isInputDisabled: false
      //     })
      // }
      // if(workflowName=="RE_KYC"&&answer.includes('JSONsplitter')){
      //     jsonData = answer.split('JSONsplitter')[1].replace(/<\/p>/g, '').replace(/<p>/g, '');
      //     var workflowJson = JSON.parse(jsonData.replace(/<br>/g, '').replace(/<p>/g, '').replace(/&nbsp;/g, '').replace(/<\/p>/g, ''));
      //     if (workflowJson.workflow === 'rekyc') {
      //         var { responseJson } = workflowJson;
      //         if(responseJson[workflowJson.workflow]==true){
      //             this.toggleFileUploadBlock(true);
      //         }
      //     }
      //     answer=answer.split('JSONsplitter')[0];
      // }

      if (answer.includes("endSplitter")) {
        endMessage = answer
          .split("endSplitter")[1]
          .replace(/<\/p>/g, "")
          .replace(/<p>/g, "");
        endDisamb = disamb;
        disamb = [];
        answer = answer.split("endSplitter")[0];
      } else if (
        answer.includes("fallbackSplitter") &&
        answer.includes("JSONsplitter")
      ) {
        remainingMessage = answer
          .split("fallbackSplitter")[1]
          .replace(/<\/p>/g, "")
          .replace(/<p>/g, "");
        jsonData = answer.split("JSONsplitter")[1];
        jsonData = jsonData.split("fallbackSplitter")[0];
        //here for masking replace added
        answer =
          answer
            .split("JSONsplitter")[0]
            .replace(/<\/p>/g, "")
            .replace(/<p>/g, "") +
          remainingMessage +
          "JSONsplitter" +
          jsonData;
      }
      if (
        answer.includes("#MyCdeeplink#") ||
        answer.includes("#MBdeeplink#") ||
        answer.includes("#UMAdeeplink#") ||
        answer.includes("#NBdeeplink#")
      ) {
        this.setState({
          removeFeedbackOption: true,
        });
      }

      if (
        answer.includes("#MyCdeeplink#") &&
        window.location.href.includes("/pb/RBLCares/mycard")
      ) {
        answer = answer.replace("#MyCdeeplink#", "");
        let myCdeeplinkData = JSON.parse(jsonData);
        this.redirectToMyCard(myCdeeplinkData.deeplink);
      }

      if (
        answer.includes("#MBdeeplink#") &&
        window.location.href.includes("/pb/RBLCares/mobanklite")
      ) {
        answer = answer.replace("#MBdeeplink#", "");
        let deeplinkData = JSON.parse(jsonData);
        //console.log(deeplinkData);
        this.redirectToMoBank(deeplinkData.deeplink);
      }
      if (
        answer.includes("#UMAdeeplink#") &&
        window.location.href.includes("/pb/RBLCares/unifiedapppre")
      ) {
        answer = answer.replace("#UMAdeeplink#", "");
        let myCdeeplinkData = JSON.parse(jsonData);
        this.redirectToMyCard(myCdeeplinkData.deeplink);
      }
      if (
        answer.includes("#UMAdeeplink#") &&
        window.location.href.includes("/pb/RBLCares/unifiedapppost")
      ) {
        answer = answer.replace("#UMAdeeplink#", "");
        let myCdeeplinkData = JSON.parse(jsonData);
        this.redirectToMyCard(myCdeeplinkData.deeplink);
      }

      if (answer.includes("#NBdeeplink#")) {
        answer = answer.replace("#NBdeeplink#", "");
        let deeplinkData = JSON.parse(jsonData);
        console.log(deeplinkData);
        this.redirectToNB(deeplinkData.deeplink);
      }

      //Link for MoBank redirection mapping

      // if(window.location.href.includes("pb/RBLCares/mobanklitepost") && answer.includes('#MBdeeplink#')){
      //     // var x = ""
      //     // x=data.EntityName+ "|" +"NULL"
      //     // if(moBankData[x] !=undefined ){
      //         redirectToMoBank(moBankData);
      //     // }
      // }else{
      //     this.setState({
      //         moBankAppsuggestionsFlag:false
      //     })
      // }

      //allow only digit for pb/..

      if (answer.includes("#digit#") && this.state.isPushBotVisible == true) {
        answer = answer.replace("#digit#", "");
        //    this.numberOnlyEnable(true);
        this.setState({
          numbersOnly: true,
        });
      } else {
        answer = answer.replace("#digit#", "");
        // this.numberOnlyEnable(false);
        this.setState({
          numbersOnly: false,
        });
      }

      //#disableForTiming# here***
      if (answer.includes("#disableForTiming#")) {
        answer = answer.replace(/#disableForTiming#/g, "");
        let time = new Date().getHours();
        let minutes = new Date().getMinutes();
        if ((time >= 18 && minutes >= 30) || (time <= 9 && minutes <= 30)) {
          //30 cal!
          // console.log("disable call now");
          answer = answer.replace("Workflow-link", "action-elem disabled");
        } else {
          //9:30-6:30
          // console.log("enable call now");
        }
      }

      //in some case workFlowFlag ture without loginIn
      //    if(data.isLoggedIn==false && data.WorkFlowflag==true && this.state.isPushBotVisible==true){
      //     this.disableInputBox(false);   //show i/p
      //    }

      //ccic
      if (
        data.isLoggedIn == false &&
        data.WorkFlowflag == true &&
        this.state.isPushBotVisible == true &&
        window.location.href.includes("pb/ccic")
      ) {
        this.disableInputBox(false); //show i/p
      }
      //kycc
      if (
        data.isLoggedIn == false &&
        data.WorkFlowflag == true &&
        this.state.isPushBotVisible == true &&
        window.location.href.includes("pb/kycc")
      ) {
        this.disableInputBox(false); //show i/p
      }

      //for push bot... hide** chatbot for pre-login
      // if (
      //   data.isLoggedIn == false &&
      //   data.WorkFlowflag == false &&
      //   this.state.isPushBotVisible == true &&
      //   !window.location.href.includes("pb/RBLCares")
      // ) {
      //   this.disableInputBox(true);
      // }
      //hide chatbox after workflow ends
      // if (
      //   data.isLoggedIn == true &&
      //   data.WorkFlowflag == false &&
      //   this.state.isPushBotVisible == true
      // ) {
      //   this.disableInputBox(true);
      // }

      //lgca** //pushbotFlowEnd**
      if (
        !data.promptLogin &&
        !data.WorkFlowflag &&
        !data.isLoggedIn &&
        answer.indexOf("thankYouMessage") < 0 &&
        answer.includes("#pushbotFlowEnd#") &&
        this.state.isPushBotVisible
      ) {
        endMessage =
          "<div id='thankYouMessage'>Thank you for showing interest. Redirecting you to RBL Bank website...</div>";
        answer = answer.replace("#pushbotFlowEnd#", "");
        this.disableInputBox(true);
      } else if (
        window.location.href.includes("pb/lglrs") &&
        !data.promptLogin &&
        !data.WorkFlowflag &&
        data.isLoggedIn &&
        answer.indexOf("thankYouMessage") < 0 &&
        answer.includes("#pushbotFlowEnd#") &&
        this.state.isPushBotVisible
      ) {
        endMessage =
          "<div id='thankYouMessage'>Thank you for showing interest. Redirecting you to RBL Bank website...</div>";
        answer = answer.replace("#pushbotFlowEnd#", "");
        this.disableInputBox(true);
      } else {
        answer = answer.replace("#pushbotFlowEnd#", "");
      }

      // pushbotFlowEnd
      if (
        !data.promptLogin &&
        !data.WorkFlowflag &&
        data.isLoggedIn &&
        answer.indexOf("thankYouMessage") < 0 &&
        answer.includes("#pushbotFlowEnd#") &&
        this.state.isPushBotVisible
      ) {
        endMessage =
          "<div id='thankYouMessage'>Thank you for showing interest. Redirecting you to RBL Bank website...</div>";
        answer = answer.replace("#pushbotFlowEnd#", "");
        this.disableInputBox(true);
      } else {
        answer = answer.replace("#pushbotFlowEnd#", "");
      }

      // if (answer.includes('##nextBubble##')) {
      //         extra_question = answer.split('##nextBubble##')[1].replace(/<\/p>/g, '').replace(/<p>/g, '').replace(/<h2>/g, '')
      //         .replace(/<\/h2>/g, '').replace(/<br>/g, '').replace(/&nbsp;/g, ' ');
      //         if(answer.split('##nextBubble##')[0].trim().length > 0) answer = answer.split(extra_question)[0]
      //         extra_question = extra_question + '#Logoless#'
      // } //  && !answer.includes('##nextBubble##')

      if (
        answer.includes("JSONsplitter") &&
        !answer.includes("fallbackSplitter")
      ) {
        jsonData = answer
          .split("JSONsplitter")[1]
          .replace(/<\/p>/g, "")
          .replace(/<p>/g, "")
          .replace(/<h2>/g, "")
          .replace(/<\/h2>/g, "");
        var workflowJson = JSON.parse(
          jsonData
            .replace(/<br>/g, "")
            .replace(/<p>/g, "")
            .replace(/&nbsp;/g, " ")
            .replace(/<\/p>/g, "")
        );
        if (workflowJson.workflow === "addUpdateEmail") {
          var { responseJson } = workflowJson;
          if (responseJson["end"] == true) {
            this.disableInputBox(true);
          }
          answer = answer.split("JSONsplitter")[0];
        }
      }

      //***BBPS**
      // else if (this.state.isBbpsBiller){
      //       if(data.WorkFlowflag == false){
      //              this.setState({
      //                isBbpsBiller: false
      //      })
      //     }else{
      //         if(answer.includes("makeBillPayment")){
      //             answer = answer;
      //         }else
      //          answer = `<div style= "width:40px; height:40px; display:inline-block;"><img style="width:100%;" src="${BBPS_Logo}" /></div>` + answer
      //         }
      // }

      if (answer.includes('"ISBILLERBBPS":"N"')) {
        this.setBbpsBiller("N");
      }
      if (answer.includes('"ISBILLERBBPS":"Y"')) {
        this.setBbpsBiller("Y");
      }

      //confirmButtonFlag for summary
      if (answer.includes("#NoConfirmSummary#")) {
        answer = answer.replace("#NoConfirmSummary#", "");
        this.setConfirmButton("N");
      }

      //deposit Interest GIF in FD
      if (answer.includes("#depositInterestGIF#")) {
        answer = answer.replace(
          "#depositInterestGIF#",
          `<div style="height:190px;text-align:center;margin-bottom:8px;margin-right:10px;" ><img style="height:100%;" src='${FDGif}' /></div>`
        );
      }

      //***emoji****/
      if (answer.includes("liabilitiesGetBillerCategories")) {
        answer = answer.replace(
          "#emoji#",
          `<div style= " height:30px; display:inline-block;"><img style="height:100%;" src="${mobile}" /></div>
               <div style= " height:30px; display:inline-block;"><img style="height:100%;" src="${electricity}" /></div>
               <div style= " height:30px; display:inline-block;"><img style="height:100%;" src="${water}" /></div>
               <div style= " height:30px; display:inline-block;"><img style="height:100%;" src="${wifi}" /></div>
               <div style= " height:30px; display:inline-block;"><img style="height:100%;" src="${books}" /></div>`
        );
      }

      if (answer.includes("#email#")) {
        answer = answer.replace(
          "#email#",
          `<div style= " height:30px; display:inline-block;"><img style="height:100%;" src="${email}" /></div>`
        );
      }

      if (answer.includes("#smiley#")) {
        answer = answer.replace("#smiley#", "🙂");
      }
      if (answer.includes("#DotIcon#")) {
        answer = answer.replace("#DotIcon#", "⏺️");
      }

      if (answer.includes('"SnpEppPlan"')) {
        answer =
          `<div>
                             Cool! 👍 Here is your EMI calculation for selected tenure. <br> Click Proceed to continue.
                      </div>` + answer;
      }
      if (answer.includes("#menu#")) {
        answer = answer.replace("#menu#", "");
      }

      var enableButton = true;
      if (answer.includes("#DontDesablePrev#")) {
        answer = answer.replace("#DontDesablePrev#", "");
        enableButton = false;
      }

      var goToTop = true;
      if (answer.includes("#GoToTop#")) {
        answer = answer.replace("#GoToTop#", "");
        goToTop = false;
      }
    } catch (error) {
      console.log(error);
    }

    let Chat = this.state.chatMessages;
    let lastChat = Chat[Chat.length - 1];
    lastChat.messageType == "server"
      ? (lastChat.isFeedbackVisible = false)
      : null;

    if (answer && answer.indexOf("logged out") > -1) {
      this.setState((prevState) => ({
        chatMessages: prevState.chatMessages.map((msg, index, arr) =>
          index === arr.length - 1 ? { ...msg, isFeedbackVisible: true } : msg
        ),
      }));
    }

    this.handleEntityName(data); // DEV 28_08_25

    this.setState(
      (prevState) => {
        return {
          chatMessages: [
            ...prevState.chatMessages,
            {
              message: answer,
              // suggestions:disamb,
              suggestions: this.state.moBankAppsuggestionsFlag ? null : disamb,
              timeStamp: TimeUtil.getCurrentTime(new Date()),
              messageType: "server",
              WorkFlowflag: data.WorkFlowflag, //&& !data.taskEnable,
              workflowName: workflowName,
              liveAgent: data.liveAgent,
              taskName,
              isFeedbackVisible: data.hasOwnProperty("isFeedbackVisible")
                ? answer && answer.indexOf("logged out") > -1
                  ? true
                  : data.isFeedbackVisible
                : true,
              key: data.key ? data.key : data.caId,
              errorFallbackLinks,
              customInfos: data.customInfos
                ? data.customInfos
                : [
                    { EntityName: data.EntityName },
                    { entityID: data.entityID },
                    { intentID: data.intentID },
                    { intentName: data.intentName },
                    { disambFlag: data.disambflag },
                  ],
              promptLogin: middleLogin
                ? "middleLogin"
                : logoutFirst
                ? "logout"
                : data.promptLogin,
              extra: data.extra,
            },
          ],
        };
      },
      () => {
        if (!data.hasOwnProperty("keepAlive") && enableButton) {
          this.disableActionLinks();
        }

        if (goToTop) {
          this._scrollToBottom("senseforth");
        }

        if (taskName == "getOTP" || taskName == "OTP") {
          let elem = document.getElementsByClassName("action-elem");
          //console.log(elem);//here for masking
          if (elem.length > 0) {
            for (let i = 0; i < elem.length; i++) {
              if (elem[i].innerHTML === "Resend OTP") {
                // only on dev
                elem[i].classList.add("disabled");
                this.initOTPTimer(elem[i]);
              }
            }
          }
          // elem.length != 0 && elem[elem.length - 1].classList.add('disabled');
          // elem.length != 0 && this.initOTPTimer(elem[elem.length - 1]);
        }

        if (endMessage.length > 0) {
          this.addServerResponse(
            { ...data, answer: endMessage, suggestions: endDisamb },
            chatInput
          );
        }

        // if(extra_question && extra_question.length > 0) {
        //     this.addServerResponse({ ...data, answer: extra_question},chatInput);
        // }
        //CASE 2
        //crest** promotion

        if (
          workflowName == "Liabilities_ResetDebitCardPin" ||
          workflowName == "Liabilities_BlockDebitCard" ||
          workflowName == "Liabilities_UnblockDebitCard" ||
          workflowName == "Liabilities_UpdateEmail" ||
          workflowName == "Liabilities_ChequekBookRequest" ||
          workflowName == "Liabilities_StopChequePayment" ||
          workflowName == "OpenFD" ||
          workflowName == "OpenRD"
        ) {
          this.setState({ currentWorkflowName: workflowName });
        }

        if (
          workflowName == "" ||
          this.state.currentWorkflowName == "Liabilities_ResetDebitCardPin" ||
          this.state.currentWorkflowName == "Liabilities_BlockDebitCard" ||
          this.state.currentWorkflowName == "Liabilities_UnblockDebitCard" ||
          this.state.currentWorkflowName == "Liabilities_UpdateEmail" ||
          this.state.currentWorkflowName == "Liabilities_ChequekBookRequest" ||
          this.state.currentWorkflowName == "Liabilities_StopChequePayment" ||
          this.state.currentWorkflowName == "OpenFD" ||
          this.state.currentWorkflowName == "OpenRD"
        ) {
          if (
            this.state.eligibleCrest == true &&
            this.state.firstWorkflow == true &&
            data.WorkFlowflag == false &&
            data.extra &&
            data.extra[0] &&
            data.extra[0].entity !== "Account" &&
            data.extra &&
            data.extra[0] &&
            data.extra[0].intent !== "complete reKYC"
          ) {
            setTimeout(() => {
              this.setState({
                isOverlayPopUpVisible: true,
                eligibleCrest: false,
                currentWorkflowName: "",
                overlayPopUpData: {
                  popupType: "Crest",
                  image: CrestGIF,
                  title: "Congratulations!",
                  subTitle: "",
                  description:
                    "You can now upgrade to Crest Debit Card and get full value Shopping Vouchers worth INR 1500 and much more!!",
                  inputString1: "I want to apply for Crest debit card.",
                  option1: "Apply Now",
                },
              });
            }, 5000);
          }
        }

        //eligibleDeposit

        if (
          workflowName == " Liabilities_TransactionHistory" ||
          workflowName == "Liabilities_FundTransfer" ||
          workflowName == "Liabilities_BeneficiaryAddition" ||
          workflowName == "Liabilities_BeneficiaryDeletion" ||
          workflowName == "CrestDebitCard" ||
          workflowName == "Liabilities_CreditScore"
        ) {
          this.setState({ currentWorkflowName: workflowName });
        }

        if (
          workflowName == "" ||
          this.state.currentWorkflowName == " Liabilities_TransactionHistory" ||
          this.state.currentWorkflowName == "Liabilities_FundTransfer" ||
          this.state.currentWorkflowName == "Liabilities_BeneficiaryAddition" ||
          this.state.currentWorkflowName == "Liabilities_BeneficiaryDeletion" ||
          this.state.currentWorkflowName == "CrestDebitCard" ||
          this.state.currentWorkflowName == " Liabilities_CreditScore"
        ) {
          if (
            this.state.eligibleDeposit == true &&
            this.state.firstWorkflow == true &&
            data.WorkFlowflag == false &&
            data.extra &&
            data.extra[0] &&
            data.extra[0].entity !== "Account" &&
            data.extra &&
            data.extra[0] &&
            data.extra[0].intent !== "complete reKYC"
          ) {
            setTimeout(() => {
              this.setState({
                isOverlayPopUpVisible: true,
                eligibleDeposit: false,
                currentWorkflowName: "",
                overlayPopUpData: {
                  popupType: "Deposit",
                  image: DepositImage,
                  title: "",
                  subTitle: "Want to grow your money?",
                  description:
                    "Just open a Term Deposit with us and earn attractive returns!!",
                  inputString1: "Apply for a deposit account",
                  option1: "Apply Now",
                },
              });
            }, 5000);
          }
        }

        if (
          workflowName == " Liabilities_AccountBalance" ||
          workflowName == "Liabilities_MiniStatement" ||
          workflowName == "Liabilities_AccountSummary"
        ) {
          this.setState({ currentWorkflowName: workflowName });
        }

        if (
          workflowName == "" ||
          this.state.currentWorkflowName == "Liabilities_AccountBalance" ||
          answer.includes("liabilitiesAccountBalance")
        ) {
          if (
            this.state.eligibleDeposit == true &&
            this.state.firstWorkflow == true &&
            data.WorkFlowflag == false &&
            data.extra &&
            data.extra[0] &&
            data.extra[0].entity !== "Account" &&
            data.extra &&
            data.extra[0] &&
            data.extra[0].intent !== "complete reKYC"
          ) {
            setTimeout(() => {
              this.setState({
                isOverlayPopUpVisible: true,
                eligibleDeposit: false,
                currentWorkflowName: "",
                overlayPopUpData: {
                  popupType: "Deposit",
                  image: DepositImage,
                  title: "",
                  subTitle: "Want to grow your money?",
                  description:
                    "Just open a Term Deposit with us and earn attractive returns!!",
                  inputString1: "Apply for a deposit account",
                  option1: "Apply Now",
                },
              });
            }, 5000);
          }
        }
        if (
          workflowName == "" ||
          this.state.currentWorkflowName == "Liabilities_MiniStatement" ||
          answer.includes("liabilitiesMiniStatement")
        ) {
          if (
            this.state.eligibleDeposit == true &&
            this.state.firstWorkflow == true &&
            data.WorkFlowflag == false &&
            data.extra &&
            data.extra[0] &&
            data.extra[0].entity !== "Account" &&
            data.extra &&
            data.extra[0] &&
            data.extra[0].intent !== "complete reKYC"
          ) {
            setTimeout(() => {
              this.setState({
                isOverlayPopUpVisible: true,
                eligibleDeposit: false,
                currentWorkflowName: "",
                overlayPopUpData: {
                  popupType: "Deposit",
                  image: DepositImage,
                  title: "",
                  subTitle: "Want to grow your money?",
                  description:
                    "Just open a Term Deposit with us and earn attractive returns!!",
                  inputString1: "Apply for a deposit account",
                  option1: "Apply Now",
                },
              });
            }, 5000);
          }
        }
        if (
          workflowName == "" ||
          this.state.currentWorkflowName == "Liabilities_AccountSummary" ||
          answer.includes("liabilitiesAccountSummary")
        ) {
          if (
            this.state.eligibleDeposit == true &&
            this.state.firstWorkflow == true &&
            data.WorkFlowflag == false &&
            data.extra &&
            data.extra[0] &&
            data.extra[0].entity !== "Account" &&
            data.extra &&
            data.extra[0] &&
            data.extra[0].intent !== "complete reKYC"
          ) {
            setTimeout(() => {
              this.setState({
                isOverlayPopUpVisible: true,
                eligibleDeposit: false,
                currentWorkflowName: "",
                overlayPopUpData: {
                  popupType: "Deposit",
                  image: DepositImage,
                  title: "",
                  subTitle: "Want to grow your money?",
                  description:
                    "Just open a Term Deposit with us and earn attractive returns!!",
                  inputString1: "Apply for a deposit account",
                  option1: "Apply Now",
                },
              });
            }, 5000);
          }
        }
      }
    );

    // console.log(data.WorkFlowflag);
    if (data.WorkFlowflag == true) {
      this.setState({
        workflowActive: true,
      });
    } else {
      this.setState({
        workflowActive: false,
      });
    }
  };

  initOTPTimer(elem) {
    setTimeout(function () {
      elem.classList.remove("disabled");
    }, 30000);
  }
  appendLoader() {
    this.setState(
      (prevState) => {
        return {
          chatMessages: [
            ...prevState.chatMessages,
            {
              message: `<div class='sf-preloader-img'><img src=${thinkingGif} /></div>`,
              timeStamp: "",
              messageType: "server",
              isFeedbackVisible: false,
              key: "preloader",
              customInfos: {},
            },
          ],
        };
      },
      () => {
        this.disableActionLinks();
        this._scrollToBottom("Me");
      }
    );
  }
  // :f
  removeLoader() {
    this.setState((prevState) => {
      return {
        chatMessages: prevState.chatMessages.filter((e) => {
          if (e.key != "preloader") return e;
        }),
      };
    });
    this._scrollToBottom("senseforth");
  }

  // _scrollToBottom(peer) {
  //   //if box(ChatBody has not loaded yet)

  //   if (!this.box.current) {
  //     return;
  //   }

  //   var box = this.box.current,
  //     t = box.scrollHeight,
  //     h = box.lastElementChild.clientHeight,
  //     prev = 0;

  //   if (peer == "Me") {
  //     box.scrollTop = t;
  //     console.log("me", box.scrollTop);
  //     var g = t * 1;
  //     prev = g;
  //   } else {
  //     // console.log(this.state.chatMessages.length);
  //     // if (this.state.chatMessages.length > 4) {
  //     try {
  //       const allWrappers = document.querySelectorAll(
  //         ".msg-wrapper.msg-server-wrapper:not(.disamb)"
  //       ) as any;
  //       box.scrollTop = allWrappers[allWrappers.length - 1].offsetTop - 110;
  //     } catch (e) {
  //       console.log(e);
  //     }
  //     // }
  //     // box.scrollTop = t - box.lastElementChild.lastElementChild.clientHeight - 150;
  //   }
  // }

  _scrollToBottom(peer) {
    if (!this.box.current) return;

    const box = this.box.current;
    const lastMessage = box.lastElementChild.lastElementChild;

    if (peer === "Me") {
      requestAnimationFrame(() => {
        box.scrollTop = box.scrollHeight - box.clientHeight;
      });
    } else {
      try {
        // PROD 03_04_25
        const userMessages = document.querySelectorAll(".msg-user-wrapper");
        const lastUserMessage = userMessages[userMessages.length - 1];
        const allServerMessages = document.querySelectorAll(
          ".msg-wrapper.msg-server-wrapper"
        );
        const lastServerMessage =
          allServerMessages[allServerMessages.length - 1];
        const secondLastServerMessage =
          allServerMessages[allServerMessages.length - 2];
        if (this.state.apiCallWithoutInput === true) {
          requestAnimationFrame(() => {
            let lastWrapper = lastServerMessage;
            if (lastWrapper)
              box.scrollTop =
                (lastWrapper as HTMLElement).offsetTop - box.clientHeight / 3;
          });
        } else if (
          secondLastServerMessage &&
          (secondLastServerMessage as HTMLElement).innerText &&
          (secondLastServerMessage as HTMLElement).innerText.indexOf(
            "logged in"
          ) > -1
        ) {
          requestAnimationFrame(() => {
            let lastWrapper = lastServerMessage;
            if (lastWrapper)
              box.scrollTop =
                (lastWrapper as HTMLElement).offsetTop - box.clientHeight / 3;
          });
        } else if (
          lastServerMessage &&
          (lastServerMessage as HTMLElement).innerText &&
          ((lastServerMessage as HTMLElement).innerText.indexOf("logged out") >
            -1 ||
            (lastServerMessage as HTMLElement).innerText.indexOf(
              "session has expired"
            ) > -1 ||
            (lastServerMessage as HTMLElement).innerText.indexOf("Great!") > -1)
        ) {
          requestAnimationFrame(() => {
            let lastWrapper = lastServerMessage;
            if (lastWrapper)
              box.scrollTop =
                (lastWrapper as HTMLElement).offsetTop - box.clientHeight / 3;
          });
        } else {
          if (lastUserMessage) {
            const lastChildServerMessages = [];
            let nextElement = lastUserMessage.nextElementSibling;
            while (nextElement) {
              if (nextElement.classList.contains("msg-server-wrapper")) {
                lastChildServerMessages.push(nextElement);
              }
              nextElement = nextElement.nextElementSibling;
            }
            if (lastChildServerMessages.length > 0) {
              if (allServerMessages.length > 0) {
                requestAnimationFrame(() => {
                  let lastWrapper =
                    allServerMessages[
                      allServerMessages.length - lastChildServerMessages.length
                    ];
                  if (lastWrapper)
                    box.scrollTop =
                      (lastWrapper as HTMLElement).offsetTop -
                      box.clientHeight / 3;
                });
              }
            } else {
              requestAnimationFrame(() => {
                let lastWrapper =
                  allServerMessages[allServerMessages.length - 1];
                if (lastWrapper)
                  box.scrollTop =
                    (lastWrapper as HTMLElement).offsetTop -
                    box.clientHeight / 3;
              });
            }
          }
        }
      } catch (e) {
        console.log("Scroll error:", e);
      }
    }
  }

  hideBot() {
    this.setState(
      {
        isBotVisible: false,
        predSearchToggle: false,
      },
      () => {
        if (this.props.netbanking && this.state.chatMessages.length < 2) {
          window["resetSessionVar"]();
          let data_SS0 = `bwayparam=${this.state.bwayparamSSO}&uniqueid=${this.state.uniqueidSSO}`;
          // console.log("KeepAlive, isLoggedIn-True");
          let formData = new FormData(); //formdata object
          formData.append("bwayparam", this.state.bwayparamSSO); //append the values with key, value pair
          formData.append("uniqueid", this.state.uniqueidSSO);
          const config = {
            headers: { "content-type": "multipart/form-data" },
          };
          // console.log("Minimise and maximise");
          Axios.post(
            wrapperEndPoint.keepAliveURL + this.state.uniqueidSSO,
            formData,
            config
          )
            .then((response) => {
              if (response.data !== "SUCCESS") {
                clearInterval(this.restartTimer);
                this.setState(
                  {
                    isSessionExpire: true,
                  },
                  () => {
                    logoutApi("logout");
                  }
                );
              } else {
                this.setState({
                  isSessionExpire: false,
                });
              }
            })
            .catch((error) => {
              this.setState(
                {
                  isSessionExpire: true,
                },
                () => {
                  logoutApi("logout");
                }
              );
              console.log(error); //handle error
            });
        }
      }
    );
  }

  clearSession() {
    if (this.state.isCrestDebitCardFlow) {
      this.crestAbortedJourney();
    }

    // Some issues with this API , sometime works sometime doesn't
    // even after removing the xtra botID in the query param
    // in the POST (that alreay has the correct payload  { botID : .. , logout : true})
    DataAPI()
      .post("/Authenticate", {
        logout: true,
      })
      .then((response) => {
        if (this.props.netbanking) {
          window["resetSessionVar"]();
          let data_SS0 = `bwayparam=${this.state.bwayparamSSO}&uniqueid=${this.state.uniqueidSSO}`;
          // console.log("KeepAlive, isLoggedIn-True");
          let formData = new FormData(); //formdata object
          formData.append("bwayparam", this.state.bwayparamSSO); //append the values with key, value pair
          formData.append("uniqueid", this.state.uniqueidSSO);
          const config = {
            headers: { "content-type": "multipart/form-data" },
          };
          // console.log("Minimise and maximise");
          Axios.post(
            wrapperEndPoint.keepAliveURL + this.state.uniqueidSSO,
            formData,
            config
          )
            .then((response) => {
              if (response.data !== "SUCCESS") {
                clearInterval(this.restartTimer);
                this.setState(
                  {
                    isSessionExpire: true,
                  },
                  () => {
                    logoutApi("logout");
                  }
                );
              } else {
                this.setState({
                  isSessionExpire: false,
                });
              }
            })
            .catch((error) => {
              this.setState(
                {
                  isSessionExpire: true,
                },
                () => {
                  logoutApi("logout");
                }
              );
              console.log(error); //handle error
            });
        }
        this.setState({
          ...this.setInitialState(),
          downTimeMsg: this.state.downTimeMsg, // UAT PREPROD 30_07_25 PROD 04_08_25
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleModalToggle(callClearSession = false) {
    if (this.props.netbanking) {
      this.setState({
        isBotIconVisible: false,
      });
    }
    if (this.props.netbanking && this.state.isSessionExpire) {
      this.setState(
        {
          isBotIconVisible: false,
        },
        () => {
          this.hideBot();
          return;
        }
      );
    }
    if (this.state.chatMessages.length < 2) {
      if (this.props.website) {
        window.location.href = "https://rbl.bank.in";
        // window.location.href="https://rblpt.rbl.bank.in"
      }
      this.hideBot();
      return;
    }
    this.toggleChatBody();
    this.setState(
      (prevState) => {
        return { isChatBodyVisible: true };
      },
      () => {
        if (callClearSession == true) {
          this.clearSession();
          if (this.props.website) {
            logoutApi(
              "logout",
              "",
              "true",
              this.props.netbanking ? "true" : ""
            );
          }
        } else {
          this.setState({
            isModalVisible: !this.state.isModalVisible,
          });
        }
      }
    );
  }

  logoutBeforeLogin = () => {
    logoutApi("logout").then(() => {});
  };

  toggleLoginScreen = (entity = false, logoutFirst = false) => {
    if (entity === true) {
      this.setState({
        showLoginScreen: false,
      });
      return;
    }
    if (entity) {
      this.setState({
        entityName: entity,
      });
    }
    if (logoutFirst) {
      this.logoutBeforeLogin();
    }
    this.setState({
      showLoginScreen: !this.state.showLoginScreen,
    });
  };

  toggleLiveAgentScreen = (close = false) => {
    if (close === true) {
      this.setState({
        showLiveAgentScreen: false,
      });
      return;
    }
    this.setState({
      showLiveAgentScreen: !this.state.showLiveAgentScreen,
    });
  };

  useSessionTimeoutHandler = () => {
    return (
      <SessionTimeoutHandler
        resetLogin={this.resetLogin}
        startSessionTimeout={this.startSessionTimeout}
        logoutUser={this.state.logoutUser}
        addServerResponse={this.addServerResponse}
        toggleSessionTimeoutPopUp={this.toggleSessionTimeoutPopUp}
        isPushBotVisible={this.state.isPushBotVisible}
        isCrestDebitCardFlow={this.state.isCrestDebitCardFlow}
        crestAbortedJourney={this.crestAbortedJourney}
        bwayparamSSO={this.state.bwayparamSSO}
        uniqueidSSO={this.state.uniqueidSSO}
        netbanking={this.props.netbanking}
      />
    );
  };

  toggleSessionTimeoutPopUp = () => {
    this.setState({
      sessionTimeout: !this.state.sessionTimeout,
    });
  };

  idleSessionTimeout = () => {
    // console.log("idle session timeout")
    clearTimeout(this.idleSessionTimer);
    this.idleSessionTimer = setTimeout(() => {
      this.setState(
        {
          isIdle: true,
        },
        () => {
          clearTimeout(this.idleSessionTimer);
          clearInterval(this.restartTimer);
        }
      );
    }, 180000);
  };

  startSessionTimeout = () => {
    let timerValue = 300000; // 300000; //default
    if (this.props.mycardApp) {
      timerValue = 180000;
    }

    clearTimeout(this.sessionTimer);

    this.sessionTimer = setTimeout(() => {
      this.setState({
        sessionTimeout: true,
      });
    }, timerValue); //300000
  };

  resetLogin = () => {
    clearInterval(this.restartTimer);
    clearTimeout(this.sessionTimer);

    this.setState({
      logoutUser: false,
    });

    // this.setState({
    //     logoutUser: false
    // },()=>{
    //     this.disableInputBox();//here disable i/p
    // })
  };

  paintChatHistory(answers) {
    let answersArray = [];
    answers.forEach((ans) => {
      answersArray.push({
        message: ans.QUESTION,
        timeStamp: ans.TIME,
        messageType: "user",
        isFeedbackVisible: false,
        key: ans.IDCHATANALYTICS,
        customInfos: {},
      });
      answersArray.push({
        message: ans.ANSWERID,
        timeStamp: ans.TIME,
        messageType: "server",
        isFeedbackVisible: false,
        key: ans.IDCHATANALYTICS,
        customInfos: {},
      });

      let data = { answer: ans.ANSWERID };
      this.addServerResponse(data);
    });

    // this.setState(prevState => {
    //     return {
    //         chatMessages: [...prevState.chatMessages,
    //         ...answersArray
    //         ]
    //     }
    // }, () => this._scrollToBottom('Me'));
  }

  loadChatHistory() {
    DataAPI()
      .get("/ChatHistory")
      .then((response) => {
        //response.data.respo && JSON.parse(response.data.actualResponse).length > 0  ? this.paintChatHistory(JSON.parse(response.data.actualResponse)) : null
        if (!!response.data) this.paintChatHistory(response.data.response);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  returnSaneURL(url) {
    return url.includes("http") ? url : window["SF_BASE_URL"] + url;
  }

  showCampaignBot = () => {
    if (this.props.data.isInsideCampaign) {
      this.setState({
        isBotVisible: true,
      });
    }
  };

  getUrlQueryParameters = (): any => {
    let queryParameters = window.location.search.slice(1),
      params = {};

    let re = /([^=]*)=([^&]*)&*/g;
    let match;
    /* 
            using assignment operator instead of equality operator in while condition which is valid.
            Ref:- https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec
            Ref:- https://www.quirksmode.org/blog/archives/2008/01/using_the_assig.html
        */
    while ((match = re.exec(queryParameters)) !== null) {
      params[match[1]] = match[2];
    }
    return params;
  };
  componentDidUpdate() {
    let thankyouElement = document.getElementById("thankYouMessage");
    if (thankyouElement != undefined) {
      this.workflowEnded();
    }
  }
  workflowEnded() {
    setTimeout(function () {
      window.location.href = "https://www.rbl.bank.in/";
    }, 10000);
  }

  crestAbortedJourney() {
    //window.alert("follow")
    let abortedJourneyData = {
      botid: "vYdoWvH2CVMbJOGnAB11VA==",
      workflowName: "CrestDebitCard",
    };

    Axios.post(wrapperEndPoint.abortedJourney, abortedJourneyData)
      .then((response) => {
        console.log(response); //handle sucess
      })
      .catch((error) => {
        console.log(error); //handle error
      });
  }

  netbankingLogout(type) {
    //NB-SSO
    logoutApi("logout");
    clearInterval(this.restartTimer);
  }

  setBotIconVisibility(flag = true) {
    let fgname =
      document.getElementById("FORMSGROUP_ID__") !== null
        ? document.getElementById("FORMSGROUP_ID__").getAttribute("value")
        : "";
    let bwayparam =
      document.getElementById(fgname + ".CUSTOM_VERIFY_URL__") !== null
        ? document
            .getElementById(fgname + ".CUSTOM_VERIFY_URL__")
            .getAttribute("value")
        : "";
    bwayparam = bwayparam.substr(bwayparam.indexOf("=") + 1, bwayparam.length);
    let uniqueid =
      document.getElementById(fgname + ".VERIFYURL_UNIQUE_ID__") !== null
        ? document
            .getElementById(fgname + ".VERIFYURL_UNIQUE_ID__")
            .getAttribute("value")
        : "";
    let CIFvalue =
      document.getElementById("CIF") !== null
        ? document.getElementById("CIF").getAttribute("value")
        : "";

    this.setState(
      {
        //data passing to sessionTimeoutHandler in keepAlive click
        bwayparamSSO: bwayparam,
        uniqueidSSO: uniqueid,
      },
      () => {
        this.triggerNBKeepAlive();
      }
    );

    this.setState({
      isBotVisible: true,
      isBotIconVisible: flag,
      isChatBodyVisible: true,
    });
  }

  handleRewardURLCall() {
    //##rewards##

    let inputString = "Proceed" + "<split>" + "Proceed";
    window["autosubmit"](inputString);

    var values = new Array(Object.values(this.state.rewardsDataJson));
    // console.log(values);
    var keys = new Array(Object.keys(this.state.rewardsDataJson));
    // console.log(keys);

    // let rewardsURL =
    //   "https://rblrewardloginportaluat.rbl.bank.in/auth/SSOLogin/"; //dev
    let rewardsURL = "https://rewards.rbl.bank.in/auth/SSOLogin"; //prod

    this.openWindowWithPost(rewardsURL, "", keys, values);
  }

  openWindowWithPost(url, name, keys, values) {
    //console.log(keys,values)

    var newWindow = window.open(url, name);

    if (!newWindow) return false;

    var html = "";
    html +=
      "<html><head></head><body><form id='formid' method='post' action='" +
      url +
      "'>";

    if (keys && values && keys.length == values.length)
      for (var i = 0; i < keys[0].length; i++)
        html +=
          "<input type='hidden' name='" +
          keys[0][i] +
          "' value='" +
          values[0][i] +
          "'/>";
    //html += "<input type='hidden' name='" + keys[0][i] + "' value='" + encodeURIComponent(values[0][i]) + "'/>";

    //  html += "<button type= 'submit' >SUBMIT</button>"
    // html += "</form></body></html>";
    html +=
      "</form><script type='text/javascript'>document.getElementById(\"formid\").submit()</script></body></html>";
    newWindow.document.write(html);
    return newWindow;
  }

  handleResetSessionVar() {
    console.log("comment this fn call");
  }
  startRestartSession = () => {
    this.restartTimer = window.setInterval(() => {
      if (!this.state.isIdle) {
        window["resetSessionVar"]();
        let data_SS0 = `bwayparam=${this.state.bwayparamSSO}&uniqueid=${this.state.uniqueidSSO}`;
        let formData = new FormData(); //formdata object
        formData.append("bwayparam", this.state.bwayparamSSO); //append the values with key, value pair
        formData.append("uniqueid", this.state.uniqueidSSO);
        console.log("KeepAlive, isLoggedIn-True");
        const config = {
          headers: { "content-type": "multipart/form-data" },
        };
        Axios.post(
          wrapperEndPoint.keepAliveURL + this.state.uniqueidSSO,
          formData,
          config
        )
          .then((response) => {
            if (response.data !== "SUCCESS") {
              clearInterval(this.restartTimer);
              this.setState(
                {
                  isSessionExpire: true,
                },
                () => {
                  logoutApi("logout");
                }
              );
            } else {
              this.setState(
                {
                  isSessionExpire: false,
                },
                () => {
                  logoutApi("logout");
                }
              );
            }
            //handle sucess
          })
          .catch((error) => {
            clearInterval(this.restartTimer);
            this.setState(
              {
                isSessionExpire: true,
              },
              () => {
                logoutApi("logout");
              }
            );

            //handle error
          });
      }
    }, 181000);
  };
  // clearStartSession(){
  //     clearInterval(this.restartTimer)
  //     this.startRestartSession()
  // }
  activeTimer(triggerNBKeepAlive) {
    let timer; //240000 = 4min

    window.onclick = resetTime;
    window.onkeypress = resetTime;
    //window.addEventListener('scroll', resetTime, true);

    function resetTime() {
      //clearStartSession()
      //triggerNBKeepAlive()
    }
  }

  triggerNBKeepAlive() {
    console.log("Trigger Keep alive");
    window["resetSessionVar"]();

    let data_SS0 = `bwayparam=${this.state.bwayparamSSO}&uniqueid=${this.state.uniqueidSSO}`;
    console.log("KeepAlive, isLoggedIn-True");
    let formData = new FormData(); //formdata object
    formData.append("bwayparam", this.state.bwayparamSSO); //append the values with key, value pair
    formData.append("uniqueid", this.state.uniqueidSSO);
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    Axios.post(
      wrapperEndPoint.keepAliveURL + this.state.uniqueidSSO,
      formData,
      config
    )
      .then((response) => {
        this.idleSessionTimeout();
        if (response.data !== "SUCCESS") {
          clearInterval(this.restartTimer);
          this.setState(
            {
              isSessionExpire: true,
            },
            () => {
              logoutApi("logout");
            }
          );
        } else {
          this.setState(
            {
              isSessionExpire: false,
            },
            () => {
              logoutApi("logout");
            }
          );
        }
      })
      .catch((error) => {
        clearInterval(this.restartTimer);
        this.setState(
          {
            isSessionExpire: true,
          },
          () => {
            this.clearSession();
            if (this.state.isLoggedIn) {
              logoutApi("logout");
            }
          }
        );
        console.log(error); //handle error
      });
    this.startRestartSession();
  }

  componentDidMount() {
    // const currentDate = new Date();
    // const startDate= new Date('2022-12-26');
    // const endDate = new Date('2023-12-27');
    // if (currentDate > startDate && currentDate < endDate) {
    //     let header edocument.querySelector('sf-header')
    // }

    console.log("NB - ", this.props.netbanking);
    window["setBotIconVisibility"] = this.setBotIconVisibility.bind(this);
    window["rewardURLcall"] = this.handleRewardURLCall.bind(this);
    window["sf-logout"] = this.netbankingLogout.bind(this);

    //window["resetSessionVar"] = this.handleResetSessionVar.bind(this); // comment this call on build
    //    var date=new Date()
    //     if(date.getDate() == 13 && date.getMonth()+1 == 5 && date.getHours()>= 9 && date.getHours()<=12){
    //         this.setState({
    //            showDownTimeModal:true
    //         })
    //     }
    if (this.props.website) {
      this.setState({
        isBotVisible: true,
      });
    }
    // let response ={"EntityName":"EMI\/Infinity Pass","workflowRelatedQn":[],"GenericResponse":false,"intentName":null,"intentID":null,"disamb":[],"entityID":null,"workflowName":"EMI_InfinityPass","liveAgent":false,"TimeStamp":"2023-02-20 12:55:46.497","disambflag":false,"promptLogout":false,"answer":"<p>JSONsplitter { \"button\" : \"Submit\",\"checkBox\" :\"true\",\"text\" :\"Yes, I want to auto-renew my EMI Infinity Pass after 12 months\",\"tcCheckBox\": \"true\",\"tcText\":\"Yes, I agree with the Terms and Conditions\",\"tcCheckBoxDefault\":\"false\",\"tcLink\": \"https:\/\/webassets.rbl.bank.in\/document\/offer-pdfs\/terms-emi-infinity-pass-20-nov-19.pdf\" } fallbackSplitter&nbsp;<\/p>","extra":[],"promptLogin":false,"isLoggedIn":false,"taskEnable":true,"WorkFlowflag":true,"taskName":"Auto_Renew","nodeID":null,"key":8065600,"NonComprehendFlag":false}
    // this.addServerResponse(response)
    if (this.props.netbanking) {
      //netbanking true if condition start**

      //keepalive call...
      let triggerNBKeepAlive = this.triggerNBKeepAlive.bind(this);

      if (!this.state.isLoggedIn) {
        window["resetSessionVar"]();
        this.activeTimer(triggerNBKeepAlive);
      }

      // let response = {"EntityName":"","workflowRelatedQn":[],"GenericResponse":false,"intentName":null,"intentID":null,"disamb":[],"entityID":null,"workflowName":"","liveAgent":false,"TimeStamp":"2021-03-29 18:31:55.063","disambflag":false,"promptLogout":false,"answer":"<p>##rekycBanking## JSONsplitter { \"ref\" : \"Xqks7b9yB9zPNkrEGfyMlw==\", \"type\" : false } fallbackSplitter <\/p>","extra":[{"question":"How can I complete the Re-KYC of my Account?","variationMatched":"<div>How can I complete the Re-KYC of my Account?","reverseIntentScore":0.6,"intentID":"48273","entityID":"26431","semantics":"","intent":"complete reKYC","semanticsequence":"<complete> <ReKYC> <Account>","entity_heirarchy":"Account","intent_score":1.0,"intent_notmatch":"All Matched","entityinContext":"true","reverseintent_notmatch":"methodenquiri kyc","nodeID":"95859","entity":"Account"}],"promptLogin":false,"isLoggedIn":true,"taskEnable":false,"WorkFlowflag":false,"taskName":"Apply","nodeID":null,"key":7942497,"NonComprehendFlag":false}
      // this.addServerResponse(response)

      //  let fgname = (document.getElementById('FORMSGROUP_ID__')!==null)?document.getElementById('FORMSGROUP_ID__').getAttribute("value"): '';
      //  let bwayparam = (document.getElementById(fgname+'.CUSTOM_VERIFY_URL__')!==null)?document.getElementById(fgname+'.CUSTOM_VERIFY_URL__').getAttribute("value"):'';
      //  bwayparam = bwayparam.substr(bwayparam.indexOf('=')+1,bwayparam.length);
      //  let uniqueid = (document.getElementById(fgname+'.VERIFYURL_UNIQUE_ID__')!==null)?document.getElementById(fgname+'.VERIFYURL_UNIQUE_ID__').getAttribute("value"):'';
      //  let CIFvalue= (document.getElementById("CIF")!==null)?document.getElementById("CIF").getAttribute("value"):'';

      //  this.setState({//data passing to sessionTimeoutHandler in keepAlive click
      //      bwayparamSSO: bwayparam,
      //      uniqueidSSO: uniqueid
      //  })

      //  let CIF_value = {customerID:CIFvalue}

      //post CIF value to API...
      //  let nbssoData

      //     Axios.post(wrapperEndPoint.CIFvalueURL, CIF_value)//customerID
      //     .then(response => {
      //            nbssoData = response.data;
      //            console.log(response)//handle sucess
      //         //  this.loadChatHistory();

      //     }).catch(error => {

      //         console.log(error);//handle error
      //     });

      //     setTimeout(() => {

      //         var loginData = {
      //                 response_type : nbssoData.authenticate_code,
      //                 cifId : CIF_value.customerID
      //         }

      //         DataAPI().post(`/loginUser`, loginData).then(({data:{q,eligibleCrest,firstWorkflow,eligibleDeposit,loggedin}})=>{
      //             this.startSessionTimeout();
      //         })
      //         .catch((error) => {
      //             console.log(error);
      //         });

      //     }, 3000);
    } //netbanking true if condition end**

    //      var iframe_tag = document.createElement('iframe');
    //           let LeadGen = "LeadGenSACB"
    //     //       var x =  `<iframe src= "https://www.googletagmanager.com/ns.html?id=GTM-5QXPKCD?utm_source=LeadGenCB?utm_medium=Chatbot?LeadSource=RBLCares?utm_campaign=${LeadGen}"
    //     //    height="0" width="0" style="display:none;visibility:hidden"></iframe>`
    // iframe_tag.src= `https://www.googletagmanager.com/ns.html?id=GTM-5QXPKCD?utm_source=LeadGenCB?utm_medium=Chatbot?LeadSource=RBLCares?utm_campaign=${LeadGen}`
    // iframe_tag.height = "0";
    // iframe_tag.width = "0";
    // iframe_tag.style.display = "none";
    // iframe_tag.style.visibility ="hidden";
    //     //  script_tag[0].innerHTML = x;
    //       document.body.appendChild(iframe_tag);

    if (!this.props.netbanking && !window.location.href.includes("pb/ccrew")) {
      //netbanking false if condition start**

      logoutApi("logout").then(() => {
        let userId_url = window.location.href;
        if (userId_url.endsWith("/")) {
          userId_url = userId_url.slice(0, -1);
        }
        // dev change 07_11_24 // PREPROD 23_12_24
        if (
          window.location.href.includes("pb/balcon") ||
          window.location.href.includes("pb/ccic") ||
          window.location.href.includes("pb/cchi") ||
          window.location.href.includes("pb/ccwp") ||
          window.location.href.includes("pb/ccac") ||
          window.location.href.includes("pb/ccuc") ||
          window.location.href.includes("pb/ccul") ||
          window.location.href.includes("pb/ccgp") ||
          window.location.href.includes("pb/ccli") ||
          window.location.href.includes("pb/cckc") ||
          window.location.href.includes("pb/cckd") ||
          window.location.href.includes("pb/ccue") ||
          window.location.href.includes("pb/upct") ||
          window.location.href.includes("/stpl-emandate") ||
          window.location.href.includes("pb/ccinf") ||
          window.location.href.includes("pb/ccrt")
        ) {
          //|| window.location.href.includes('/stpl')
          let userId = null;
          if (userId_url.includes("?")) {
            userId = userId_url.substring(userId_url.lastIndexOf("?") + 1);
            if (userId.length >= 12 && userId.length <= 20) {
              // var Base_URL = "https://chatbotdev.rbl.bank.in/rcb/GenericChatBot/service/GenericApiRouter";
              var Base_URL = wrapperEndPoint.genericRouterURL;
              var xhttp = new XMLHttpRequest();
              xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                  var val = JSON.parse(this.responseText);
                  if (
                    val.Status == "Success" || //snpplus and balcon and activate card
                    val.Status === "Success" ||
                    val.Status === "no active plan" || //inactive bot, activateCard bot
                    (val.result.status === "success" &&
                      (val.response.planResponse === "more plan" ||
                        val.response.planResponse === "No active plan"))
                  ) {
                    //health insurance & Wallet Protection &upgrade card & Upgrade limit & gadget protect & life insurance & kyc appointment & kyc upload & update email id & upsell criteria
                  } else {
                    alert("Invalid User");
                  }
                }
              };
              xhttp.open("POST", Base_URL, true);
              xhttp.setRequestHeader("Content-Type", "application/json");
              var data = null;

              // dev change 07_11_24 // PREPROD 23_12_24
              let endPoint = {
                "pb/balcon": "CcSnpPlusBalconIdentifyUser",
                "pb/ccic": "identifyUserInactiveBot",
                "pb/cchi": "validateUserHDFCInsu",
                "pb/ccwp": "validateUserWalletProtectation",
                "pb/ccac": "identifyUserActivateCard",
                "pb/ccuc": "CcUpgradeCard",
                "pb/ccul": "CcUpgradeLimit",
                "pb/ccgp": "validateUserGadgetProtect",
                "pb/ccli": "validateUserLifeInsurance",
                "pb/cckc": "validateUserKycAppointment",
                "pb/cckd": "validateUserKycDocument",
                "pb/ccue": "validateUserEmailID",
                "pb/upct": "validateUserUpsell",
                "/stpl-emandate": "CcIdentifyUserEmandate",
                "pb/ccinf": "identifyUserForInfinityPassEMI",
                "pb/ccrt": "identifyUserRetentionBot",
              };
              for (const [key, value] of Object.entries(endPoint)) {
                if (window.location.href.includes(key)) {
                  if (window.location.href.includes("pb/ccue")) {
                    data = {
                      wrapperEndPoint: "/RBLWrapper/rbl/creditCard/" + value,
                      findIFSC: userId + " rbl",
                    };
                  } else {
                    data = {
                      wrapperEndPoint: "/RBLWrapper/rbl/creditCard/" + value,
                      findIFSC: userId,
                    };
                  }

                  break;
                }
              }
              xhttp.send(JSON.stringify(data));
            } else {
              alert("Invalid User");
            }
          } else {
            alert("Invalid User");
          }
        }

        if (window.location.search.slice(1).includes("query=")) {
          this.showBot();
          let query = this.getUrlQueryParameters()["query"];

          if (query.includes("%20")) {
            // console.log("query= ",query)

            query = query.replace(/%20/g, " ");
            // console.log("query= ",query)

            // Str.replace(/_/g, "-");
          }

          if (`${query}` == "hello") {
            //do nothing

            this.setState({
              showWelcomeScreen: false,
            });
            var queryMsg = `Hey! How can I help you today?`;
            this.addServerResponse({ answer: queryMsg });

            let queryData = {
              botid: "vYdoWvH2CVMbJOGnAB11VA==",
              url: window.location.href,
            };
            // console.log(queryData);

            Axios.post(wrapperEndPoint.queryAnalytics, queryData)
              .then((response) => {
                console.log(response); //handle sucess
              })
              .catch((error) => {
                console.log(error); //handle error
              });
          } else {
            this.handleSubmit(`${query}`, true);
            // var queryMsg = `Hi! How can I help you today?`;
            // this.addServerResponse({ answer: queryMsg});
          }
        }

        if (window.location.href.includes("pb/RBLCares")) {
          this.showBot();
          // this.handleSubmit("hello", true);
          this.setState((prevState) => {
            return {
              chatMessages: [
                ...prevState.chatMessages,
                {
                  message: "Hey! How can I help you today?",
                  timeStamp: TimeUtil.getCurrentTime(new Date()),
                  isFeedbackVisible: false,
                  key: null,
                  messageType: "server",
                  customInfos: {},
                },
              ],
            };
          });
        }

        // if (window.location.href.includes('pb/ccli')) {
        //     this.showBot();
        //     this.setState(prevState => {
        //         return {
        //             chatMessages: [...prevState.chatMessages, {
        //                 message: "Hi, please wait while I check your eligibility.",
        //                 timeStamp: TimeUtil.getCurrentTime(new Date()),
        //                 isFeedbackVisible: false,
        //                 key: null,
        //                 messageType: 'server',
        //                 customInfos: {},
        //             }]
        //         }
        //     })
        // }

        userId_url.endsWith("/")
          ? (userId_url = userId_url.slice(0, -1))
          : null;
        let userId = null;
        if (userId_url.includes("?")) {
          userId = userId_url.substring(userId_url.lastIndexOf("?") + 1);
          if (userId.length >= 12 && userId.length <= 20) {
            this.setState({ uniqueUserId: userId });
          }
        }

        const pb_autosubmit = {
          "pb/fd": "I want to open a Fixed Deposit account",
          "pb/deposit": "Apply for a deposit",
          "pb/crest": "I want to apply for Crest debit card",
          "pb/e": "I want to update my email address",
          "pb/kycc": "I want to know about Credit Cards",
          "pb/sccp": "I want to know more about setting a Credit Card pin.",
          "pb/cli": "Tell me about pushbot cli",
          "pb/rccs": "How to read Credit Card Statement",
          "pb/pccs": "How can I pay my credit card bills?",
          "pb/dcon": "How to apply for pre approved Credit Card?",
          "pb/ccso": "how to shop online?",
          "pb/ccwp": "Tell me about Wallet Protection",
          "pb/snpplus": "How can I book split N pay plus",
          "pb/balcon": "How can I book split N pay balcon",
          "pb/ccic": "Tell me about Credit Card inactive chatbots",
          "pb/cchi": "Tell me about Health Insurance Policy",
          "pb/ccac": "how to activate my new credit card",
          "pb/lgca": "Apply for current account",
          "pb/lgsa": "Apply for savings account",
          "pb/lgnd": "Apply for NRI deposit",
          "pb/lgna": "How can I open an NRI account with RBL Bank?",
          "pb/lgofd": "I want to open a fixed deposit account",
          "pb/ccuc": "How to upgrade my Credit Card?",
          "pb/ccul": "How to upgrade my Credit Limit?",
          "pb/ubpip": "How can I pay my Utility Bill?",
          "pb/ccgp": "What is gadget protect?",
          "pb/hosp": "I want to apply for hospicash.",
          "pb/hllead": "I want to apply for Home Loan.",
          "pb/ccli": " Tell me about RBL Life Insurance?",
          "pb/ccoc": "tell me about your offers",
          "pb/cckc": "How can I book KYC appointment for Credit Card?",
          "pb/cckd": "Upload KYC Documents  online",
          "pb/upct": "Tell me about upsell criteria",
          "pb/ccue":
            "I want to update my Email ID for the credit card account.",
          "pb/ubpap": "I want to set autopay for my utility bill.",
          "pb/chequeauth": "I want to authorize cheque",
          "pb/rekycacc": "How can I complete the Re-KYC of my Account?",
          "pb/stpl": "Apply for STPL",
          "pb/xcash": "I want to apply for Xpress Cash.",
          "pb/lglrs":
            "How can I transfer funds quickly and easily with RBL bank outward remittance?",
          "pb/ccinf": "How can I get an EMI Infinity pass?",
          "pb/ccrt": "I want to know about credit card cancellation.",
          "pb/ccrew": "I want to raise a complaint for credit card rewards.",
          "pb/chqbk": "I want to apply for a cheque book.",
          "pb/ccpin": "How do I reset credit card pin?",
          "pb/cccontrol": "Switch on or off credit card",
          "pb/tracksr": "I want to track my service request", // DEV PREPROD 23-12-2024
        };

        // for (const [key, value] of Object.entries(pb_autosubmit)) {
        //     if(window.location.href.includes(key)){
        //         if(window.location.href.includes('pb/snpplus') || window.location.href.includes('pb/balcon') || window.location.href.includes('pb/ccic') ||
        //         window.location.href.includes('pb/cchi') || window.location.href.includes('pb/ccwp') || window.location.href.includes('pb/ccac') ||
        //         window.location.href.includes('pb/ccuc') || window.location.href.includes('pb/ccul') || window.location.href.includes('pb/ccgp') ||
        //         window.location.href.includes('pb/ccli') || window.location.href.includes('pb/cckc') || window.location.href.includes('pb/cckd') ||
        //         window.location.href.includes('pb/ccue') || window.location.href.includes('pb/upct') || window.location.href.includes('pb/xcash') ||
        //         window.location.href.includes('pb/stpl')){

        //             this.showBot();
        //             this.handleSubmit(value + userId, true);//merging trigger query if Uid present

        //         }
        //         else{

        //             this.showBot();
        //             this.handleSubmit(value, true);
        //         }

        //     }
        //   }

        for (const [key, value] of Object.entries(pb_autosubmit)) {
          if (window.location.href.includes(key)) {
            if (window.location.href.includes("pb/ccue")) {
              this.showBot();
              this.handleSubmit(value + userId + " rbl", true); //merging trigger query if Uid present
            } else {
              this.showBot();
              this.handleSubmit(value, true);
            }
          }
        }

        // else if(window.location.href.indexOf("?RBLCares")>-1){
        //     this.showBot();
        //     this.handleSubmit('hi', true);
        // }

        //to check reponse in testUI //
        // let response =
        // {"EntityName":"","workflowRelatedQn":[],"GenericResponse":false,"intentName":null,"intentID":null,"disamb":[],"entityID":null,"workflowName":"","liveAgent":false,"TimeStamp":"2021-07-05 17:10:52.947","disambflag":false,"promptLogout":false,"answer":"<p>Here you go! The last transaction/s details of your Card ending &nbsp;XXXXXXXXXXXXXX39.<\/p>\n<p>&nbsp;JSONsplitter{\"workflow\":\"creditCardMiniStatement\",\"responseJson\":{\"creditCardMiniStatement\":[{\"amount\":\"499\",\"remarks\":\"PAYMENT RECEIVED - ELECTRONIC\",\"date\":\"24\/06\/2021\",\"type\":\"Credited\"},{\"amount\":\"49\",\"remarks\":\"PAYMENT RECEIVED - ELECTRONIC\",\"date\":\"19\/01\/2021\",\"type\":\"Credited\"},{\"amount\":\"49\",\"remarks\":\"PAYMENT RECEIVED - ELECTRONIC\",\"date\":\"19\/01\/2021\",\"type\":\" Debited\"},{\"amount\":\"433\",\"remarks\":\"PAYMENT RECEIVED - ELECTRONIC\",\"date\":\"09\/11\/2020\",\"type\":\"Credited\"}]}}endSplitter<\/p>","extra":[{"question":"How can I check if there is any debit on my Credit Card?","variationMatched":"How can I check if there is any debit on my Credit Card?","reverseIntentScore":1.0,"intentID":"48400","entityID":"26437","semantics":"","intent":"Check Debit","semanticsequence":"<check> <debited> <Credit Card>","entity_heirarchy":"Credit Card","intent_score":1.0,"intent_notmatch":"All Matched","entityinContext":"true","reverseintent_notmatch":"All Matched","nodeID":"96114","entity":"Credit Card"}],"promptLogin":false,"isLoggedIn":true,"taskEnable":false,"WorkFlowflag":false,"taskName":"transactionDetails","nodeID":null,"key":7976713,"NonComprehendFlag":false}

        // this.addServerResponse(response)
      });
    } //netbanking flag false if condition end**

    if (window.location.href.includes("pb/ccrew")) {
      this.showBot();
      // this.handleSubmit("I want to raise a complaint for credit card rewards.", true);

      let sendData = {
        payload: this.getUrlQueryParameters()["payload"],
        //ucicid: "TTGSrcuLAJjapNMmrsvXyw==",
        // loyaltyId: "ff4e24af92ad4d9c3e27537e5875eeddacdb6b55398c8ed2e004141351cf22c7"
      };

      let rewssoData;
      DataAPI()
        .post(
          `/loginUser`,
          JSON.stringify({ botid: "vYdoWvH2CVMbJOGnAB11VA==", type: "logout" })
        )
        .then(
          ({
            data: {
              q,
              eligibleCrest,
              firstWorkflow,
              eligibleDeposit,
              loggedin,
            },
          }) => {
            Axios.post(wrapperEndPoint.CCRewardsURL, sendData) //customerID
              .then((response) => {
                rewssoData = response.data;
                let loyalty_id = response.data.loyalty_id;
                let key = response.data.cardNumber;
                let accountNo = response.data.accountNo; // PROD 03_04_25 PREPROD 02_04_25
                if (response.data.status == "LoggedIn") {
                  Axios.post(wrapperEndPoint.loyaltyRewards, {
                    loyalty_id: loyalty_id,
                    selectedCardNo: key,
                    accountNo: accountNo, // PROD 03_04_25 // PREPROD 02_04_25
                  }).then((response) => {
                    //  console.log(response)
                    setTimeout(() => {
                      var loginData = {
                        response_type: rewssoData.authenticate_code,
                        cifId: "TTGSrcuLAJjapNMmrsvXyw==",
                      };

                      // console.log(loginData)

                      DataAPI()
                        .post(`/loginUser`, loginData)
                        .then(
                          ({
                            data: {
                              q,
                              eligibleCrest,
                              firstWorkflow,
                              eligibleDeposit,
                              loggedin,
                            },
                          }) => {
                            this.handleSubmit(
                              "I want to raise a complaint for credit card rewards.",
                              true
                            );
                            this.startSessionTimeout();
                          }
                        )
                        .catch((error) => {
                          console.log(error);
                        });
                    }, 3000);
                  });
                } else {
                  this.handleSubmit(
                    "I want to raise a complaint for credit card rewards.",
                    true
                  );
                }
              })
              .catch((error) => {
                console.log(error); //handle error
              });
          }
        );
    }

    isInsignia();
    //based on url isPushBotVisible flag will be true
    let pb_path = [
      "pb/fd",
      "pb/deposit",
      "pb/e",
      "pb/crest",
      "pb/kycc",
      "pb/sccp",
      "pb/snpplus",
      "pb/balcon",
      "pb/rccs",
      "pb/pccs",
      "pb/dcon",
      "pb/ccic",
      "pb/ccso",
      "pb/cli",
      "pb/cchi",
      "pb/ccwp",
      "pb/lgca",
      "pb/lgsa",
      "pb/lgnd",
      "pb/lgna",
      "pb/lgofd",
      "pb/ccac",
      "pb/ccuc",
      "pb/ccul",
      "pb/ubpip",
      "pb/ccgp",
      "/pb/hosp",
      "pb/ccli",
      "pb/ccoc",
      "pb/cckc",
      "pb/cckd",
      "pb/ccue",
      "pb/upct",
      "pb/ubpap",
      "pb/chequeauth",
      "/pb/rekycacc",
      "/pb/xcash",
      "/pb/stpl",
      "pb/lglrs",
      "pb/ccinf",
      "pb/ccrt",
      "pb/ccrew",
      "pb/chqbk",
      "/pb/hllead",
    ];
    // for(const path of pb_path){
    //     if(window.location.href.includes(path)){
    //         this.setState({isPushBotVisible: true});
    //         break;
    //     }
    // }
    if (window.location.href.includes("/pb/")) {
      this.setState({ isPushBotVisible: true });
    }

    if (
      this.props.data.enableChatHistory &&
      JSON.parse(this.props.data.enableChatHistory)
    )
      this.loadChatHistory();

    if (
      this.props.data.autoPopTime &&
      this.props.data.autoPopTime != "" &&
      this.props.data.autoPopTime > 0
    ) {
      var tmRef = window.setTimeout(() => {
        if (!this.state.isBotVisible) {
          this.showBot();
          window.clearTimeout(tmRef);
        }
      }, +this.props.data.autoPopTime * 1000);
    }

    window["autosubmit"] = this.handleSubmit.bind(this);
    //   window["justUIPrint"] = this.handleJustUIPrintCall.bind(this);
    window["autoCNClinksubmit"] = this.handleCNCLinksClick.bind(this);

    // window["autoquicklinksubmit"] = this.handleQuickLinkSubmit.bind(this);
    window["changeChatMessages"] = this.changeChatMessages.bind(this);
    this.showCampaignBot();
    //CNC
    window["CNCLinksClick"] = this.handleCNCLinksClick.bind(this);
    /**
     * Handle clicks on anchor tags
     */
    const elem = document.querySelector(".sf-chatbot");
    if (elem) {
      elem.addEventListener("click", (event) => {
        this.idleSessionTimeout();
        if (this.state.isIdle) {
          // if the user starts conversation after idle session.re initatiting the call
          this.setState(
            {
              isIdle: false,
            },
            () => {
              if (this.props.netbanking) {
                console.log("After idle call");
                this.triggerNBKeepAlive();
              }
            }
          );
        }
        const target = event.target as any;
        if (target.nodeName === "A") {
          const href = target.href;
          this.anchorTagClickHandler(href, (data) => {
            event.preventDefault();
            this.handleSubmit(data);
          });
        }
      });
    }

    Axios.get(wrapperEndPoint.PlannedDownTimeURL, {
      withCredentials: false,
    }).then((respponse) => {
      let resp = respponse.data;
      if (resp.downtime === "yes" || resp.downtime.indexOf("yes") > -1) {
        var downTimeMsg = resp.message
          .replace("#date", resp.details.date)
          .replace("#startTime", resp.details.startTime)
          .replace("#endTime", resp.details.endTime);
        this.setState({
          isDownTimeAlertVisible: true, // UAT 28_7_25 // UAT PREPROD 30_07_25 PROD 04_08_25
          downTimeMsg: downTimeMsg,
          // downTimeST: resp.details.startTime,
          // downTimeET: resp.details.endTime,
        });
      } else {
        this.setState({
          isDownTimeAlertVisible: false,
          downTimeMsg: "",
        });
      }
    });
  }

  handleFeedBackStar = (starCount) => {
    this.setState({ selectedStar: starCount });
  };

  anchorTagClickHandler(data, cb) {
    const autoSubmitRegex = /javascript:autosubmit\('(.*)'\)/;
    const matches = autoSubmitRegex.exec(data);
    if (matches) {
      const valueOfAutosubmit = matches[1];
      cb(valueOfAutosubmit);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.sessionTimer);
    clearInterval(this.restartTimer);
    clearTimeout(this.idleSessionTimer);
  }

  showBot() {
    this.setState({ isBotVisible: true });
    // let resp ={
    //     "downtime": "no",
    //     "message": "RBL Cares - your digital assistant is under maintenance on #date, #startTime to #endTime. Inconvenience is regretted.",
    //     "details": {
    //         "date": "30th December 2023",
    //         "startTime": "12 AM",
    //         "endTime": "2 AM"
    //     }
    // }
    // Axios.get(wrapperEndPoint.PlannedDownTimeURL ,{ withCredentials: false})
    // .then(respponse => {
    //     let resp= respponse.data;
    //     if(resp.downtime === "yes" || resp.downtime.indexOf("yes") > -1) {
    //         var downTimeMsg = resp.message.replace("#date", resp.details.date).replace("#startTime",resp.details.startTime).replace("#endTime",resp.details.endTime);
    //         this.setState({
    //             isDownTime: true,
    //             downTimeMsg: downTimeMsg,
    //             // downTimeST: resp.details.startTime,
    //             // downTimeET: resp.details.endTime,
    //         })
    //     }
    // })
  }

  hideWelcomeScreen() {
    this.setState({
      showWelcomeScreen: false,
    });
  }

  render() {
    return (
      <div>
        <SFIconStyles styles={this.props.data} />

        <BotIcon
          isBotVisible={this.state.isBotVisible}
          isBotIconVisible={this.state.isBotIconVisible}
          logoImagePath={this.props.data.logoImagePath}
          returnSaneURL={this.returnSaneURL}
          showBot={this.showBot.bind(this)}
          isMobileApp={this.props.mobankApp}
          isNetBanking={this.props.netbanking}
        />

        <AppStyles styles={this.props.data} />
        <ChatStyles styles={this.props.data} />
        <div
          className="sf-chatbot"
          style={{ display: this.state.isBotVisible ? "block" : "none" }}
        >
          <Header
            botName={this.props.botName}
            isSessionExpire={this.state.isSessionExpire}
            toggleOverlay={this.toggleOverlay.bind(this)}
            toggleChatBody={this.toggleChatBody.bind(this)}
            isChatBodyVisible={this.state.isChatBodyVisible}
            hideBot={this.hideBot.bind(this)}
            handleModalToggle={this.handleModalToggle.bind(this)}
            data={this.props.data}
            logoImagePath={this.props.data.logoImagePath}
            redirectToExternalBot={this.redirectToExternalBot}
            theme={this.state.selectedTheme}
            handleLogout={this.handleLogout}
            isLoggedIn={this.state.isLoggedIn}
            isPushBotVisible={this.state.isPushBotVisible}
            netbanking={this.props.netbanking}
            isBotVisible={this.state.isBotVisible}
            setBotIconVisibility={this.setBotIconVisibility.bind(this)}
          />
          <React.Suspense fallback={<div>Loading...</div>}>
            <ChatOverlay
              toggleOverlay={this.toggleOverlay.bind(this)}
              isOverlayVisible={this.state.isOverlayVisible}
              data={this.props.data}
            />
          </React.Suspense>
          {this.state.isBotVisible ? (
            <React.Suspense fallback={<div>Loading...</div>}>
              <ChatBody
                boxRef={this.box}
                website={this.props.website}
                chatMessages={this.state.chatMessages}
                isChatBodyVisible={this.state.isChatBodyVisible}
                chatInput={this.state.chatInput}
                chatInputDisplayValue={this.state.chatInputDisplayValue}
                handleInput={this.handleInput.bind(this)}
                handleKeyUp={this.handleKeyUp.bind(this)}
                handleKeyDown={this.handleKeyDown.bind(this)}
                handleSubmit={this.handleSubmit.bind(this)}
                quickLinks={this.props.botQuickLinks}
                isSpeech={this.state.isSpeech}
                data={this.props.data}
                handleFocus={this.handleFocus.bind(this)}
                predSearchToggle={this.state.predSearchToggle}
                predSearchResponse={this.state.predSearchResponse}
                togglePredSearch={this.togglePredSearch.bind(this)}
                assignPredSearchQues={this.assignPredSearchQues.bind(this)}
                theme={this.state.selectedTheme}
                showWelcomeScreen={this.state.showWelcomeScreen}
                toggleLoginScreen={this.toggleLoginScreen.bind(this)}
                logoImagePath={this.props.data.logoImagePath}
                BbpsFlag={this.state.isBbpsBiller}
                NoConfirmButton={this.state.isConfirmButtonVisible}
                isInputDisabled={this.state.isInputDisabled}
                isPushBotVisible={this.state.isPushBotVisible}
                numbersOnly={this.state.numbersOnly}
                logoutUser={this.state.isLoggedIn}
                transactionResponseAarry={this.transactionResponseAarry}
                storeChecklist={this.storeChecklist.bind(this)}
                // handleModalToggle={this.handleModalToggle.bind(this)}
                handleFeedBackStar={this.handleFeedBackStar}
                handleQuickLinkSubmit={this.handleQuickLinkSubmit.bind(this)}
                isFeedbackEnable={this.state.isFeedbackEnable}
                mobankApp={this.props.mobankApp}
                mycardApp={this.props.mycardApp}
                addServerResponse={this.addServerResponse.bind(this)}
                handleJustUIPrintCall={this.handleJustUIPrintCall.bind(this)}
                CNCLinksOnClick={this.state.CNCLinksOnClick}
                netbanking={this.props.netbanking}
                bwayparamSSO={this.state.bwayparamSSO}
                uniqueidSSO={this.state.uniqueidSSO}
                isLoggedIn={this.state.isLoggedIn}
                setWorkflowName={this.state.setWorkflowName}
                checkBoxJsonData={this.state.checkBoxJsonData}
                checkBoxFlag={this.state.checkBoxFlag}
                termsCheckBox={this.state.termsCheckBox}
                termsCheckBoxFlag={this.state.termsCheckBoxFlag}
                termsText={this.state.termsText}
                termsLink={this.state.termsLink}
                hideWelcomeScreen={this.hideWelcomeScreen.bind(this)}
                showRewardCalender={this.state.showRewardCalender}
                removeFeedbackOption={this.state.removeFeedbackOption}
              />
            </React.Suspense>
          ) : null}
          {this.state.isModalVisible ? (
            <React.Suspense fallback={<div>Loading...</div>}>
              <SFModal isModalVisible={this.state.isModalVisible}>
                <ClearSessionOverlay
                  handleModalToggle={this.handleModalToggle.bind(this)}
                  data={this.props.data}
                  logoutUser={this.state.logoutUser}
                  selectedStar={this.state.selectedStar}
                  website={this.props.website}
                  isFeedbackEnable={this.state.isFeedbackEnable}
                />
              </SFModal>
            </React.Suspense>
          ) : null}
          {this.state.isGettingStarted ? ( // UAT PREPROD 30_07_25 PROD 04_08_25
            <React.Suspense fallback={<div>Loading...</div>}>
              <SFModal isModalVisible={this.state.isModalVisible}>
                <div className="sf-chatmodal-overlay">
                  <div
                    className="sf-chatmodal-body"
                    style={{ transform: "translateY(-10%)" }}
                  >
                    <div
                      className="sf-chatmodal-content"
                      style={{ padding: "32px 2.7em 2.7em" }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <div
                          style={{
                            color: "#2c387a",
                            marginBottom: "16px",
                            fontWeight: "bold",
                            fontSize: "18px",
                          }}
                        >
                          Hi! Welcome to RBL Cares Chatbot, your banking best
                          friend.
                        </div>
                        <div style={{ marginBottom: "16px" }}>
                          I am here to make your banking simpler and quicker by
                          helping you anytime you need.
                        </div>
                        {/* <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: this.props.netbanking
                              ? "32px"
                              : "16px",
                            gap: "8px",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="sf-rbl-tnc-checkbox"
                            style={{
                              cursor: "pointer",
                              width: "24px",
                              height: "24px",
                            }}
                            checked={this.state.tncChecked || false}
                            onChange={(e) =>
                              this.setState({ tncChecked: e.target.checked })
                            }
                          />
                          <label
                            htmlFor="sf-rbl-tnc-checkbox"
                            style={{
                              lineHeight: "normal !important",
                              fontSize: "14px !important",
                              color: "#000 !important",
                            }}
                          >
                            <div
                              className="label-text"
                              style={{
                                lineHeight: "normal !important",
                                fontSize: "14px !important",
                                color: "#000 !important",
                              }}
                            >
                              By continuing, you agree to the{" "}
                              <a
                                href={
                                  wrapperEndPoint.tncLinks ||
                                  "https://d37h1lausy4x10.cloudfront.net/document/chatbot/ChatbotTermsAndConditions.pdf"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Terms &amp; Conditions
                              </a>
                              .
                            </div>
                          </label>
                        </div> */}
                        <button
                          className="sf-chatmodal-btn sf-confirm"
                          style={{
                            // opacity: this.state.tncChecked ? 1 : 0.5,
                            // cursor: this.state.tncChecked
                            //   ? "pointer"
                            //   : "not-allowed",
                            opacity: 1,
                            cursor: "pointer",
                            color: "#fff",
                            padding: "10px 24px",
                            border: "none",
                            borderRadius: "4px",
                            background: "#2c387a",
                          }}
                          onClick={() => {
                            // const checkbox = document.getElementById(
                            //   "sf-rbl-tnc-checkbox"
                            // ) as HTMLInputElement;
                            // if (checkbox && checkbox.checked) {
                              this.setState({
                                isGettingStarted: false,
                                isDownTime: this.state.isDownTimeAlertVisible,
                              });
                            // }
                          }}
                        >
                          Get Started
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </SFModal>
            </React.Suspense>
          ) : null}
          {this.state.isDownTime ? (
            <React.Suspense fallback={<div>Loading...</div>}>
              <SFModal isModalVisible={this.state.isModalVisible}>
                <div className="sf-chatmodal-overlay">
                  <div className="sf-chatmodal-body" style={{ top: "40%" }}>
                    {/* <img className="sf-notice-close" src={close} onClick={()=>{this.setState({showDownTimeModal:false})}}></img> */}
                    <div
                      className="sf-chatmodal-content"
                      style={{ padding: "32px 2.7em 2.7em" }}
                    >
                      <div className="sf-notice-text">Service Alert!!</div>
                      <div className="sf-notice">
                        {/* In our endeavour to serve you better, RBL Bank systems will be upgraded between {this.state.downTimeST} to {this.state.downTimeET} on {this.state.downTimeDate}. During this time, banking services - MoBank, ATM, Internet Banking, NEFT, RTGS, UPI/IMPS will not be accessible. We sincerely regret any inconvenience caused. Kind Regards. */}
                        {this.state.downTimeMsg}
                      </div>
                      <button
                        className="sf-chatmodal-btn sf-confirm"
                        style={{ background: "#2c387a", marginTop: "10px" }}
                        onClick={() => {
                          this.setState({
                            isDownTime: false,
                            isDownTimeAlertVisible: false,
                          });
                        }}
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                </div>
              </SFModal>
            </React.Suspense>
          ) : null}
          {this.state.isSessionExpire && this.state.isChatBodyVisible ? (
            <React.Suspense fallback={<div>Loading...</div>}>
              <SFModal
                isModalVisible={this.state.isModalVisible}
                isExpire={true}
              >
                <div className="sf-chatmodal-overlay">
                  <div
                    className="sf-chatmodal-body"
                    style={{ top: "40%", height: "120px" }}
                  >
                    <div
                      className="sf-chatmodal-content"
                      style={{ padding: "2.7em" }}
                    >
                      <p>Your session has expired!</p>
                    </div>
                  </div>
                </div>
              </SFModal>
            </React.Suspense>
          ) : null}
          {this.state.showLoginScreen ? (
            <React.Suspense fallback={<div>Loading...</div>}>
              <LoginScreen
                addServerResponse={this.addServerResponse}
                toggleLoginScreen={this.toggleLoginScreen.bind(this)}
                loginType={this.state.entityName} // DEV 28_08_25
                startSessionTimeout={this.startSessionTimeout}
                isPushBotVisible={this.state.isPushBotVisible}
                preLoginQuestion={this.state.preLoginQuestion}
                netbanking={this.props.netbanking}
              />
            </React.Suspense>
          ) : null}
          {/*|| this.state.logoutUser*/}

          {this.state.sessionTimeout || this.state.logoutUser
            ? this.useSessionTimeoutHandler()
            : null}

          {this.state.showLiveAgentScreen ? (
            <LiveAgentScreen
              showLiveAgentScreen={this.state.showLiveAgentScreen}
              isChatBodyVisible={this.state.isChatBodyVisible}
              liveAgentData={this.state.liveAgentData}
              startSessionTimeout={this.startSessionTimeout}
              toggleLiveAgentScreen={this.toggleLiveAgentScreen}
            />
          ) : null}
          {this.state.isOverlayPopUpVisible ? (
            <OverlayMessage
              toggleCrestPromotionPopUp={this.toggleCrestPromotionPopUp.bind(
                this
              )}
              overlayPopUpData={this.state.overlayPopUpData}
            />
          ) : null}

          {this.state.rekycBankingData.flag ? (
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "50px",
                left: "0",
                background: "white",
              }}
            >
              <div
                onClick={() => this.handleExitRekycBankingOverlay()}
                style={{ position: "absolute", top: "20px", right: "28px" }}
              >
                <img src={close}></img>
              </div>

              <iframe
                id="rekycIframeItem"
                width="100%"
                height="100%"
                src={this.state.rekycBankingData.url}
                //    onLoad={()=>this.handleExitRekycBankingMessage()}

                // onLoad={()=>{
                //     console.log('hello')
                //     let iframe=document.getElementById('rekycIframeItem') as HTMLIFrameElement
                //     let iWin=iframe.contentWindow.document.body;
                //     let iDoc=iframe.contentDocument.body;
                //     // console.log("hello",iframe,iWin,iDoc,iWin.document,iWin.document.body,iDoc.body)
                //     iWin.getElementsByClassName('btn btn-bluenew')[0].addEventListener("click", function(event){
                //      console.log('working');
                //      this.handleExitRekycBankingOverlay();
                //     });
                // }}
              ></iframe>
            </div>
          ) : null}

          {/* {this.props.netbanking?
                        <script
                            src={`${window['SF_OAUTH_URL']}/AuthServlet?client_id=yNXLk/MUjADz9tO6wRh81Q==&client_secret=/BQmP1hj1eYEa+QhUyadcw==&response_type=PXqSI2+Nqkx4e51cD+NcTQ==&redirect_uri=9OgluN1w6z6Pa+AsIowGXw==`} 
                            >
                        </script> 
                    :null
                    } */}
        </div>
      </div>
    );
  }
}

export default App;
